// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   Screen-level layout

   The shared structure every screen follows on mobile:

     Top app bar   (appbar.css)
     Page header   — one title, optional one-line context, no breadcrumb
     Content       — sections at the 16px gutter, cards, lists
     Primary action— sticky when the screen has one that matters
     Bottom nav    (untouched)
   ════════════════════════════════════════════════════════════════════════ */

/* ── The shell ──────────────────────────────────────────────────────────── */
html.m-app .app-shell {
  background: var(--m-surface-page);
  /* Belt and braces with the existing bottom-nav padding rule: this one is
     safe-area aware, so on a gesture-nav phone the last row of content
     clears the home indicator too. */
  min-height: 100dvh;
}

html.m-app .app-shell-with-bottom-nav {
  padding-bottom: var(--m-bottomnav-total);
}

/* Every page container drops the desktop's centred max-width and generous
   vertical padding down to the mobile gutter. */
html.m-app :is(
  .settings-page, .settings-container,
  .dash-page, .oh-page, .pdp-page, .wl-page, .ntf-page,
  .ab-page, .pf-page, .cartpg-grid, .checkout-container,
  .about-page, .contact-page, .faq-page, .careers-page,
  .privacy-page, .cookie-page, .ret-page, .brands-page
) {
  max-width: none;
  width: 100%;
  margin: 0;
  padding-left: var(--m-gutter);
  padding-right: var(--m-gutter);
  padding-top: var(--m-4);
}

/* Multi-column page grids become one column. */
html.m-app :is(
  .settings-grid, .cartpg-grid, .cookie-layout, .checkout-grid,
  .dash-grid, .pdp-layout, .oh-layout, .about-grid
) {
  display: flex;
  flex-direction: column;
  gap: var(--m-4);
}

html.m-app :is(.settings-side-column, .cartpg-side, .cartpg-col, .cookie-side) {
  display: flex;
  flex-direction: column;
  gap: var(--m-4);
  width: 100%;
}

/* ── Page header ────────────────────────────────────────────────────────
   One title at 22px, one line of context at 13px. The desktop versions run
   to 34px with a breadcrumb trail underneath; on a phone the app bar
   already says where you are, and the OS back gesture is the trail. */
html.m-app :is(
  .settings-page-heading, .oh-page-header, .ab-page-hdr,
  .pf-page-hdr, .wl-page-hdr, .ntf-page-hdr, .m-page-header
) {
  margin: 0 0 var(--m-4);
  padding: 0;
  border: none;
}

html.m-app :is(
  .settings-page-heading h1, .oh-page-header h1, .ab-page-title,
  .pf-page-title, .wl-page-title, .ntf-page-title, .dash-greeting,
  .cartpg-hd-title, .m-page-title
) {
  font-size: var(--m-fs-page-title);
  font-weight: var(--m-fw-bold);
  line-height: var(--m-lh-tight);
  letter-spacing: var(--m-track-title);
  margin: 0 0 var(--m-1);
}

html.m-app :is(
  .settings-page-heading p, .ab-page-sub, .pf-page-sub,
  .wl-page-sub, .ntf-page-sub, .m-page-sub
) {
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  color: var(--color-text-secondary);
  margin: 0;
}

/* Breadcrumbs: the app bar's back button already carries this, and a trail
   of four links at the top of a phone screen is four mis-tap targets. */
html.m-app :is(.oh-breadcrumb, .pdp-breadcrumb, .breadcrumb, .cookie-breadcrumb) {
  display: none;
}

/* Section heading inside a screen: title left, one optional link right. */
html.m-app :is(.sf-section-hd, .dash-section-hdr, .m-section-hd) {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--m-3);
  padding: 0 var(--m-gutter);
  margin: var(--m-5) 0 var(--m-3);
}

html.m-app :is(.sf-section-hd h2, .dash-section-hdr h2, .m-section-hd h2) {
  font-size: var(--m-fs-section);
  font-weight: var(--m-fw-semibold);
  letter-spacing: var(--m-track-title);
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--m-2);
}

html.m-app :is(.dash-section-link, .m-section-link, .sf-section-hd a) {
  flex: 0 0 auto;
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-medium);
  color: var(--color-secondary-text);
  white-space: nowrap;
}

/* Sections already inside a gutter-padded page must not double-indent. */
html.m-app :is(.settings-page, .dash-page, .oh-page) :is(.sf-section-hd, .dash-section-hdr, .m-section-hd),
html.m-app :is(.settings-page, .dash-page, .oh-page) .product-grid {
  padding-left: 0;
  padding-right: 0;
}

/* ════════════════════════════════════════════════════════════════════════
   Home / storefront
   ════════════════════════════════════════════════════════════════════════ */

/* Delivery address row: a single 44px line, not a 68px banner. */
html.m-app .mtb-delivery-row {
  display: flex;
  align-items: center;
  gap: var(--m-2);
  width: 100%;
  min-height: var(--m-touch);
  padding: var(--m-2) var(--m-gutter);
  border: none;
  border-bottom: 1px solid var(--m-hairline);
  background: var(--m-surface-card);
}

html.m-app .mtb-delivery-text {
  display: flex;
  align-items: baseline;
  gap: var(--m-1);
  min-width: 0;
  flex: 1 1 auto;
}

html.m-app .mtb-delivery-label {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-regular);
  text-transform: none;
  letter-spacing: 0;
  color: var(--color-text-muted);
  white-space: nowrap;
}

html.m-app .mtb-delivery-value {
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-semibold);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

/* Category rail: compact tiles, ~5 visible with the sixth peeking. */
html.m-app .mtb-cat-strip {
  display: flex;
  gap: var(--m-1);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  padding: var(--m-3) var(--m-gutter);
  background: var(--m-surface-card);
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .mtb-cat-strip::-webkit-scrollbar { display: none; }

html.m-app .mtb-cat-tile {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--m-1);
  width: 64px;
  min-height: 62px;
  padding: var(--m-1);
  border: none;
  border-radius: var(--m-r-sm);
  background: transparent;
  scroll-snap-align: start;
}

html.m-app .mtb-cat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--m-r-pill);
  background: var(--m-surface-sunken);
  color: var(--color-text-primary);
}

html.m-app .mtb-cat-icon svg { width: var(--m-icon); height: var(--m-icon); }

html.m-app .mtb-cat-tile.active .mtb-cat-icon {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}

html.m-app .mtb-cat-label {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-medium);
  line-height: 1.15;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

html.m-app .mtb-cat-tile.active .mtb-cat-label {
  color: var(--color-secondary-text);
  font-weight: var(--m-fw-semibold);
}

/* Recently viewed rail */
html.m-app .mtb-recent { padding: var(--m-4) 0 0; }

html.m-app .mtb-recent-title {
  display: flex;
  align-items: center;
  gap: var(--m-2);
  font-size: var(--m-fs-section);
  font-weight: var(--m-fw-semibold);
  margin: 0 var(--m-gutter) var(--m-3);
}

html.m-app .mtb-recent-strip {
  display: flex;
  gap: var(--m-3);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  padding: 0 var(--m-gutter);
}

html.m-app .mtb-recent-strip::-webkit-scrollbar { display: none; }

html.m-app .mtb-recent-card {
  flex: 0 0 auto;
  width: 110px;
  padding: 0;
  border: none;
  background: transparent;
  text-align: left;
  scroll-snap-align: start;
}

html.m-app .mtb-recent-img-wrap {
  display: block;
  width: 110px;
  height: 110px;
  border-radius: var(--m-r-sm);
  overflow: hidden;
  background: var(--m-surface-sunken);
  margin-bottom: var(--m-2);
}

html.m-app .mtb-recent-img { width: 100%; height: 100%; object-fit: cover; }

html.m-app .mtb-recent-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
}

html.m-app .mtb-recent-price {
  display: block;
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-bold);
  margin-top: 2px;
}

/* Hero carousel.

   App.css already has a genuinely mobile treatment for this at <=600px: one
   slide at 88% width (so the next peeks), a 185px box, an 18px title and
   .slide-body hidden. That is the right shape, and an earlier pass here
   broke it by re-showing .slide-body and pushing the title back up to 22px —
   which overflowed the 185px slide and clipped the CTA off the bottom.

   So this deliberately does NOT restyle the slide's copy. It only removes
   the overlay arrows (two 28px targets sitting on the slide's own tap area,
   below the 44px floor, and redundant with the swipe the track already
   supports), aligns the rail to the 16px gutter, and gives the CTA a real
   touch target. */
html.m-app .hero-carousel {
  margin: var(--m-3) 0;
}

html.m-app .carousel-track {
  padding-inline: var(--m-gutter);
  gap: var(--m-3);
}

html.m-app .carousel-slide {
  border-radius: var(--m-r);
  box-shadow: var(--m-shadow-sm);
}

html.m-app .slide-cta {
  min-height: var(--m-touch);
  padding: 0 var(--m-4);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-button);
  font-weight: var(--m-fw-semibold);
}

html.m-app .slide-badge,
html.m-app .slide-discount-badge {
  font-size: var(--m-fs-caption);
  padding: 2px var(--m-2);
  border-radius: var(--m-r-pill);
}

html.m-app .carousel-arrow {
  display: none;
}

html.m-app .carousel-dots,
html.m-app .cat-carousel-dots {
  display: flex;
  justify-content: center;
  gap: var(--m-1);
  padding: var(--m-2) 0 0;
}

html.m-app .carousel-dot,
html.m-app .cat-carousel-dot {
  width: 6px;
  height: 6px;
  min-height: 6px;
  border-radius: var(--m-r-pill);
  background: var(--m-hairline-strong);
  transition: width var(--m-dur) var(--m-ease);
}

html.m-app .carousel-dot.active,
html.m-app .cat-carousel-dot.active {
  width: 18px;
  background: var(--color-secondary);
}

/* Trust list (cart / checkout reassurance).

   This is a vertical list separated by hairlines, not a horizontal strip —
   an earlier pass turned it into a scroller and left the icons and copy
   misaligned. It stays a list; only the measure changes. */
html.m-app .cs-trust-item {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  padding: var(--m-3) 0;
  border-top: 1px solid var(--m-hairline);
}

html.m-app .cs-trust-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  flex: 0 0 auto;
}

html.m-app .cs-trust-icon svg { width: var(--m-icon); height: var(--m-icon); }

html.m-app .cs-trust-title {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
}

html.m-app .cs-trust-sub {
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  color: var(--color-text-secondary);
}

/* The storefront's sort control sits beside a 24px "All Products" heading
   on desktop; on mobile the heading shrinks and sort becomes a chip. */
html.m-app .shop-toolbar,
html.m-app .sf-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--m-2);
  padding: 0 var(--m-gutter);
  margin-bottom: var(--m-3);
}

html.m-app .sf-toolbar select,
html.m-app .shop-toolbar select {
  width: auto;
  min-width: 0;
  height: 36px;
  min-height: 36px;
  padding: 0 var(--m-6) 0 var(--m-3);
  border-radius: var(--m-r-pill);
  font-size: var(--m-fs-secondary);
  background-color: var(--m-surface-card);
}

/* Desktop filter sidebar → a sheet, opened from the toolbar. */
html.m-app .sf-sidebar,
html.m-app .shop-sidebar {
  display: none;
}

/* ════════════════════════════════════════════════════════════════════════
   Product detail

   The heaviest screen in the app. Order on mobile: image, identity, price,
   then everything else — with the buy action pinned so it's reachable from
   any scroll position instead of living 400px down.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .pdp-page {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  /* Clears the pinned buy bar, which sits above the bottom nav. */
  padding-bottom: calc(var(--m-control-lg) + var(--m-5));
}

/* Gallery: edge to edge, no card frame. A bordered, rounded, shadowed box
   around a product photo is a desktop convention — on a phone the image is
   the screen, and the frame just costs 16px of width on both sides plus a
   visual seam between the photo and the page.

   The frame lives on .pdp-main-img-wrap, not .pdp-gallery (which is only
   the flex row pairing the thumbnails with the stage). */
html.m-app .pdp-gallery {
  width: 100%;
  gap: 0;
  margin: 0 0 var(--m-3);
  padding: 0;
}

html.m-app .pdp-main-img-wrap {
  border: none;
  border-radius: 0;
  box-shadow: none;
  background: var(--m-surface-card);
}

/* 320px of forced min-height plus a 420px fixed image height overflowed
   the stage on a 390px screen. The stage becomes a true square sized by its
   own aspect ratio (flex:0 0 auto so it isn't squashed by the quantity row
   below it), and the image is told to fit inside that square rather than
   carry a fixed pixel height of its own.

   Zoom-on-hover is removed: there is no hover on a phone, and the transform
   left the photo mid-scale after a tap. */
html.m-app .pdp-main-img-stage {
  flex: 0 0 auto;
  min-height: 0;
  /* 4:3 rather than square. Product photos here are predominantly
     landscape, and \`object-fit: contain\` (correct — a product must never be
     cropped) letterboxes whatever the frame doesn't match. A square frame
     left ~90px of empty white between the photo and the quantity row on
     every listing; 4:3 spends that space on the photo instead, and a
     portrait image still fits, just with padding at the sides. */
  aspect-ratio: 4 / 3;
  cursor: default;
}

html.m-app .pdp-main-img-stage:hover .pdp-main-img-inner {
  transform: none;
}

/* The base rule pins this to height:420px, which is taller than the stage
   it lives in. border-box is the load-bearing part: without it the 12px
   padding is added *outside* the 100% height and the photo bleeds past both
   edges of its own box. */
html.m-app .pdp-main-img,
html.m-app .pdp-main-img-fallback {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: var(--m-3);
  object-fit: contain;
}

/* Quantity sits inside the image card on desktop. On mobile it belongs
   with the buy action in the sticky bar, so it comes out of the gallery. */
/* Quantity sits inside the image card on desktop. It stays there rather
   than moving into the sticky bar — the bar already holds two actions and a
   third control would crowd all three under the 44px floor — but it gets a
   hairline of its own and label styling so it reads as a control, not a
   caption floating under the photo. */
html.m-app .pdp-img-qty-row {
  justify-content: space-between;
  gap: var(--m-3);
  padding: var(--m-2) var(--m-gutter);
  min-height: var(--m-touch);
  border-top: 1px solid var(--m-hairline);
}

html.m-app .pdp-img-config-label {
  font-size: var(--m-fs-label);
  font-weight: var(--m-fw-medium);
  color: var(--color-text-secondary);
  min-width: 0;
}

/* Prev/next overlay buttons duplicate the swipe the track already
   supports, and sit on top of the image's own tap target. */
html.m-app .pdp-img-prev,
html.m-app .pdp-img-next {
  display: none;
}

html.m-app .pdp-img-counter,
html.m-app .pdp-img-badge {
  font-size: var(--m-fs-caption);
  padding: 2px var(--m-2);
  border-radius: var(--m-r-pill);
}

/* The thumbnail rail is a vertical column beside the image on desktop and
   is flipped to a row underneath it at tablet width. Here it's a horizontal
   scroller on the gutter, and it collapses entirely for a single-image
   product rather than leaving an orphaned 52px square. */
html.m-app .pdp-thumbs,
html.m-app .pdp-thumb-strip {
  display: flex;
  flex-direction: row;
  gap: var(--m-2);
  overflow-x: auto;
  scrollbar-width: none;
  padding: var(--m-3) var(--m-gutter) 0;
}

html.m-app .pdp-thumbs:not(:has(.pdp-thumb + .pdp-thumb)) {
  display: none;
}

html.m-app .pdp-thumbs::-webkit-scrollbar,
html.m-app .pdp-thumb-strip::-webkit-scrollbar { display: none; }

html.m-app .pdp-thumb {
  flex: 0 0 auto;
  width: 52px;
  height: 52px;
  min-height: 52px;
  border-radius: var(--m-r-xs);
}

html.m-app .pdp-info,
html.m-app .pdp-summary {
  padding: 0 var(--m-gutter);
}

html.m-app .pdp-cat-label {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-semibold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-secondary-text);
  margin-bottom: var(--m-1);
}

html.m-app .pdp-title,
html.m-app .pdp-page h1 {
  font-size: var(--m-fs-page-title);
  font-weight: var(--m-fw-bold);
  line-height: var(--m-lh-tight);
  letter-spacing: var(--m-track-title);
  margin: 0 0 var(--m-2);
  padding: 0 var(--m-gutter);
}

html.m-app .pdp-price,
html.m-app .pdp-price-now {
  font-size: 1.5rem;    /* 24px — the only number on the screen this size */
  font-weight: var(--m-fw-bold);
  letter-spacing: var(--m-track-title);
  font-variant-numeric: tabular-nums;
}

html.m-app .pdp-price-was {
  font-size: var(--m-fs-body);
  color: var(--color-text-muted);
  text-decoration: line-through;
}

/* Share is a secondary action; on desktop it's a row of three labelled
   buttons above the fold. It moves into the app bar's overflow on mobile —
   here it's simply out of the primary reading path. */
/* Share is a secondary action. Left as a wrapping row it took two lines
   and 106px directly under the product title, above the price. It becomes
   a single scrolling line of small chips. */
html.m-app .pdp-share-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(--m-2);
  padding: var(--m-2) var(--m-gutter) var(--m-3);
  overflow-x: auto;
  scrollbar-width: none;
}

html.m-app .pdp-share-row::-webkit-scrollbar { display: none; }

html.m-app .pdp-share-row > span:first-child {
  font-size: var(--m-fs-label);
  color: var(--color-text-muted);
  flex: 0 0 auto;
}

html.m-app .pdp-share-row button,
html.m-app .pdp-share-row a {
  flex: 0 0 auto;
  min-height: 36px;
  padding: 0 var(--m-3);
  border-radius: var(--m-r-pill);
  font-size: var(--m-fs-secondary);
}

html.m-app .pdp-badges-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--m-2);
  padding: 0 var(--m-gutter);
  margin-bottom: var(--m-3);
}

html.m-app .pdp-bestseller-badge {
  font-size: var(--m-fs-caption);
  padding: var(--m-1) var(--m-2);
  border-radius: var(--m-r-pill);
}

/* Long-form blocks — description, specs, delivery options, benefits,
   frequently-bought-together, reviews, Q&A — become collapsed sections so
   the page is scannable rather than a 5000px scroll. */
html.m-app :is(
  .pdp-desc-section, .pdp-specs-section, .pdp-delivery-card,
  .pdp-benefits-card, .pdp-buyer-protection, .pdp-fbt-card,
  .pdp-reviews-section, .pdp-qa-section
) {
  margin: 0 var(--m-gutter) var(--m-3);
  padding: var(--m-4);
  border-radius: var(--m-r);
  border: 1px solid var(--m-hairline);
  background: var(--m-surface-card);
  box-shadow: var(--m-shadow-sm);
}

html.m-app .pdp-desc-short,
html.m-app .pdp-desc-list {
  font-size: var(--m-fs-body);
  line-height: var(--m-lh-body);
}

html.m-app .pdp-feature-chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--m-2);
}

html.m-app .pdp-feature-chip {
  font-size: var(--m-fs-caption);
  padding: var(--m-1) var(--m-2);
  border-radius: var(--m-r-pill);
}

/* Colour swatches: real targets, and the product's own colours are exempt
   from the four-colour palette by design. */
html.m-app .pdp-colors-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: var(--m-2);
  padding: 0 var(--m-gutter) var(--m-3);
}

html.m-app .pdp-color-swatch {
  width: 36px;
  height: 36px;
  min-height: 36px;
  border-radius: var(--m-r-pill);
}

html.m-app .pdp-colors-label,
html.m-app .pdp-del-section-title {
  font-size: var(--m-fs-label);
  font-weight: var(--m-fw-medium);
  color: var(--color-text-secondary);
  padding: 0 var(--m-gutter);
  margin-bottom: var(--m-2);
}

/* Delivery options as choice rows. */
html.m-app .pdp-del-opt {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  min-height: 56px;
  padding: var(--m-2) 0;
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .pdp-del-name { font-size: var(--m-fs-body); font-weight: var(--m-fw-medium); }
html.m-app .pdp-del-date { font-size: var(--m-fs-caption); color: var(--color-text-secondary); }
html.m-app .pdp-del-price { font-size: var(--m-fs-secondary); font-weight: var(--m-fw-semibold); margin-left: auto; }

/* ── Sticky buy bar ─────────────────────────────────────────────────────
   Add to Cart / Buy Now live in .pdp-sidebar-actions, roughly 900px down a
   5600px page. Rather than render a second copy of them (which would mean
   duplicating the variant/size validation each button runs, and risking the
   two drifting apart), the existing block is pinned in place. Same nodes,
   same handlers, same state — just always reachable.

   Stacked vertically on desktop, they sit side by side here, with a clear
   hierarchy rather than two identical orange slabs: Add to Cart takes the
   solid orange fill the design system reserves for the primary commercial
   action, and Buy Now becomes an outline of the same hue. */
html.m-app .pdp-sidebar-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--m-bottomnav-total);
  z-index: 190;
  flex-direction: row;
  align-items: center;
  gap: var(--m-2);
  padding: var(--m-2) var(--m-gutter);
  padding-left: max(var(--m-gutter), var(--m-safe-left));
  padding-right: max(var(--m-gutter), var(--m-safe-right));
  background: var(--m-surface-bar);
  border-top: 1px solid var(--m-hairline);
  box-shadow: var(--m-shadow-sticky);
}

@supports (backdrop-filter: blur(12px)) {
  html.m-app .pdp-sidebar-actions {
    background: color-mix(in srgb, var(--m-surface-bar) 90%, transparent);
    backdrop-filter: saturate(180%) blur(16px);
    -webkit-backdrop-filter: saturate(180%) blur(16px);
  }
}

html.m-app .pdp-sidebar-actions .pdp-add-cart-btn,
html.m-app .pdp-sidebar-actions .pdp-buy-now-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--m-2);
  flex: 1 1;
  width: auto;
  min-height: var(--m-control-lg);
  padding: 0 var(--m-3);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-button);
  font-weight: var(--m-fw-semibold);
  letter-spacing: 0;
  white-space: nowrap;
}

html.m-app .pdp-sidebar-actions svg { flex: 0 0 auto; }

/* Buy Now steps back to an outline so the two actions aren't equally
   prominent. The gradient and its orange glow are dropped: a heavy drop
   shadow under a bar that's already elevated reads as two stacked layers. */
html.m-app .pdp-sidebar-actions .pdp-buy-now-btn {
  background: transparent;
  border: 1.5px solid var(--color-primary);
  color: var(--color-text-primary);
  box-shadow: none;
}

html.m-app .pdp-sidebar-actions .pdp-add-cart-btn {
  background: var(--color-primary);
  /* Navy on orange: 7.4:1. White would be 2.8:1. */
  color: var(--color-text-on-primary);
  box-shadow: none;
}

/* The back-in-stock form replaces the buy actions when a product is
   unavailable; it's a form, not a one-tap action, so it stays in flow. */
html.m-app .pdp-notify-wrap {
  margin: 0 var(--m-gutter) var(--m-3);
  padding: var(--m-4);
  border-radius: var(--m-r);
}

html.m-app .pdp-benefit-title { font-size: var(--m-fs-body); font-weight: var(--m-fw-medium); }
html.m-app .pdp-benefit-sub { font-size: var(--m-fs-caption); color: var(--color-text-secondary); }
html.m-app .pdp-benefit-item { gap: var(--m-3); padding: var(--m-2) 0; }
html.m-app .pdp-benefit-icon svg { width: var(--m-icon); height: var(--m-icon); }

/* ════════════════════════════════════════════════════════════════════════
   Cart and checkout
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .cs-item {
  display: flex;
  align-items: flex-start;
  gap: var(--m-3);
  padding: var(--m-3) 0;
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .cs-item-img,
html.m-app .cs-item img {
  width: 64px;
  height: 64px;
  min-width: 64px;
  border-radius: var(--m-r-xs);
  object-fit: cover;
}

html.m-app .cs-item-name {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-medium);
  line-height: var(--m-lh-snug);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

html.m-app .cs-item-price {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-bold);
  font-variant-numeric: tabular-nums;
}

html.m-app .cs-item-action {
  min-height: var(--m-touch);
  font-size: var(--m-fs-secondary);
  padding: 0 var(--m-2);
}

/* Free-shipping progress */
html.m-app .cs-fs-bar { padding: var(--m-3); border-radius: var(--m-r-sm); }
html.m-app .cs-fs-title { font-size: var(--m-fs-secondary); font-weight: var(--m-fw-semibold); }
html.m-app .cs-fs-sub { font-size: var(--m-fs-caption); }
html.m-app .cs-fs-track { height: 6px; border-radius: var(--m-r-pill); }

/* Empty cart: one illustration at a sane size, one leading action. The
   second button drops to a text link so the two don't compete. */
html.m-app .cs-empty,
html.m-app .cartpg-empty-layout {
  padding: var(--m-8) var(--m-gutter);
  gap: var(--m-2);
}

html.m-app .cs-empty-illustration {
  transform: scale(0.62);
  transform-origin: center;
  margin: calc(var(--m-6) * -1) 0;
}

html.m-app .cs-empty-title {
  font-size: var(--m-fs-section);
  font-weight: var(--m-fw-semibold);
}

html.m-app .cs-empty-sub {
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
  max-width: 32ch;
}

html.m-app .cs-empty-continue-btn {
  width: 100%;
  min-height: var(--m-control-lg);
  border-radius: var(--m-r-sm);
  font-size: 1rem;
  font-weight: var(--m-fw-semibold);
  background: var(--color-secondary);
  /* Navy on blue: 5.6:1. The white this replaced was 3.1:1. */
  color: var(--color-text-on-secondary);
  border: none;
}

html.m-app .cs-empty-categories-btn {
  width: 100%;
  min-height: var(--m-touch);
  background: transparent;
  border: none;
  color: var(--color-secondary-text);
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-medium);
}

/* Order summary: a tight table of figures. The discount row is the one
   place in the app a rate may be shown, and it stays exactly as the server
   returned it. */
html.m-app :is(.cod-order-recap, .cs-totals, .co-recap) {
  padding: var(--m-4);
  border-radius: var(--m-r);
  border: 1px solid var(--m-hairline);
  background: var(--m-surface-card);
}

html.m-app :is(.cs-total-row, .price-row, .discount-row) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--m-3);
  min-height: 30px;
  font-size: var(--m-fs-body);
  font-variant-numeric: tabular-nums;
}

html.m-app :is(.cs-total-row, .price-row) span:last-child {
  font-weight: var(--m-fw-medium);
}

html.m-app .total,
html.m-app .cs-total-row.total {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-bold);
  padding-top: var(--m-3);
  margin-top: var(--m-2);
  border-top: 1px solid var(--m-hairline);
}

html.m-app .checkout-step-pad {
  padding: 0 0 var(--m-4);
}

html.m-app .co-panel {
  margin-bottom: var(--m-3);
}

/* .co-radio is the 18px radio DOT, not a choice row -- it is rendered as a
   bare <span className="co-radio co-radio-on" />. An earlier pass here
   mistook it for a row and gave it min-height:56px plus padding and a
   border; inside the payment card's flex row that stretched it into a tall
   blue ellipse about 40x130. It keeps its own size. */
html.m-app .co-radio {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  padding: 0;
  margin-top: 0;
  align-self: center;
}

html.m-app .payment-method-card {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  min-height: 60px;
  padding: var(--m-3);
  border-radius: var(--m-r-sm);
  margin-bottom: var(--m-2);
}

/* .coupon-section already stacks a label above a .coupon-input-row; making
   the section itself a flex row put the "Have a coupon?" label BESIDE the
   input, squeezing the field to about 90px and clipping its placeholder.
   The section is the column; the inner row is the row. */
html.m-app .coupon-section {
  display: flex;
  flex-direction: column;
  gap: var(--m-2);
  /* The base draws this as a DASHED border on a tinted fill. At this size a
     dash pattern reads as a broken or placeholder edge rather than a
     deliberate one -- especially against the dashed connector already used
     in the order tracker, where dashes mean "not yet". A solid hairline on
     the card surface says "this is a field group", which is what it is.

     Padding restated because the base's 18px/20px was not surviving here,
     so the label and the input row sat flush against the border. */
  padding: var(--m-3);
  border: 1px solid var(--m-hairline-strong);
  border-radius: var(--m-r-sm);
  background: var(--m-surface-card);
  box-shadow: none;
}

/* The label inside the box: sentence case at label size. The base
   uppercases it and adds letter-spacing, which at 12px in a small box
   fights the placeholder directly beneath it for attention. */
html.m-app .coupon-section h3 {
  margin: 0;
  font-size: var(--m-fs-label);
  font-weight: var(--m-fw-medium);
  color: var(--color-text-secondary);
  text-transform: none;
  letter-spacing: 0;
}

html.m-app .coupon-input-row {
  display: flex;
  align-items: center;
  gap: var(--m-2);
  width: 100%;
}

/* No icon in the field. A ticket glyph beside a box labelled "Have a
   coupon?" restates the label and costs the input ~28px of the little width
   it has -- the field was 183px on a 360px screen. Input and action, nothing
   else. (The tick/cross on the feedback line below stays: those carry the
   result, and in a four-colour system a status may not rest on hue alone.) */
html.m-app .coupon-ticket-icon {
  display: none;
}

html.m-app .coupon-input {
  flex: 1 1 auto;
  min-width: 0;
  height: var(--m-control);
  padding: 0 var(--m-3);
  border: 1px solid var(--m-hairline-strong);
  border-radius: var(--m-r-sm);
  background: var(--m-surface-card);
  font-size: 1rem;
  text-transform: uppercase;
}

html.m-app .coupon-input::placeholder {
  font-size: var(--m-fs-body);
  text-transform: none;
  color: var(--color-text-muted);
}

html.m-app .coupon-apply-btn {
  flex: 0 0 auto;
  min-height: var(--m-control);
  padding: 0 var(--m-4);
  white-space: nowrap;
}

/* ════════════════════════════════════════════════════════════════════════
   Account area
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .dash-greeting {
  padding: 0 0 var(--m-4);
}

/* Recent orders as list rows rather than a table. */
html.m-app .dash-order-row {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  min-height: 60px;
  padding: var(--m-3) 0;
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .dash-order-id { font-size: var(--m-fs-body); font-weight: var(--m-fw-medium); }
html.m-app .dash-order-date { font-size: var(--m-fs-caption); color: var(--color-text-secondary); }
html.m-app .dash-order-total {
  margin-left: auto;
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  font-variant-numeric: tabular-nums;
}

html.m-app .dash-card-strip {
  display: flex;
  gap: var(--m-3);
  overflow-x: auto;
  scrollbar-width: none;
  padding-bottom: var(--m-2);
}

html.m-app .dash-card-strip::-webkit-scrollbar { display: none; }

html.m-app .dash-mini-card {
  flex: 0 0 auto;
  width: 120px;
}

html.m-app .dash-empty {
  padding: var(--m-6) 0;
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
  text-align: center;
}

/* Profile identity card */
html.m-app .pf-avatar,
html.m-app .profile-avatar {
  width: 56px;
  height: 56px;
  min-width: 56px;
}

html.m-app .pf-name,
html.m-app .profile-name {
  font-size: var(--m-fs-section);
  font-weight: var(--m-fw-semibold);
}

html.m-app .pf-meta-row {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  min-height: var(--m-touch);
  padding: var(--m-2) 0;
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .pf-meta-label {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
}

html.m-app .pf-meta-value {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-medium);
}

/* Notifications: list rows with an unread marker that isn't only colour. */
html.m-app .ntf-item {
  display: flex;
  gap: var(--m-3);
  align-items: flex-start;
  padding: var(--m-3) var(--m-gutter);
  border-bottom: 1px solid var(--m-hairline);
  background: var(--m-surface-card);
}

html.m-app .ntf-item.unread {
  background: var(--color-secondary-soft);
}

html.m-app .ntf-title {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
}

html.m-app .ntf-body {
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
  line-height: var(--m-lh-snug);
}

html.m-app .ntf-time {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
  white-space: nowrap;
}

/* Addresses */
html.m-app .ab-card {
  padding: var(--m-4);
}

html.m-app .ab-card-name { font-size: var(--m-fs-body); font-weight: var(--m-fw-semibold); }
html.m-app .ab-card-lines { font-size: var(--m-fs-secondary); color: var(--color-text-secondary); line-height: var(--m-lh-snug); }

html.m-app .ab-card-actions {
  display: flex;
  gap: var(--m-2);
  margin-top: var(--m-3);
  padding-top: var(--m-3);
  border-top: 1px solid var(--m-hairline);
}

html.m-app .ab-card-actions button {
  flex: 1 1;
  min-height: var(--m-touch);
  font-size: var(--m-fs-secondary);
}

/* Settings privacy block: one leading action, one destructive text action —
   not two full-width filled buttons side by side. */
html.m-app .settings-privacy-actions {
  flex-direction: column;
  gap: var(--m-2);
  margin-top: var(--m-4);
}

html.m-app .settings-download-btn {
  background: var(--color-secondary);
  /* Navy on blue: 5.6:1, replacing white at 3.1:1. */
  color: var(--color-text-on-secondary);
  border-color: transparent;
}

html.m-app .settings-delete-btn {
  width: 100%;
  min-height: var(--m-touch);
  background: transparent;
  border: 1px solid var(--m-hairline-strong);
}

html.m-app .settings-privacy-note {
  margin-top: var(--m-3);
  padding: var(--m-3);
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  border-radius: var(--m-r-sm);
}

/* The <br> in the privacy note forces an awkward break at this width. */
html.m-app .settings-privacy-note br { display: none; }

html.m-app .settings-privacy-footer {
  flex-wrap: wrap;
  gap: var(--m-2);
  min-height: 0;
  margin-top: var(--m-5);
  padding-top: var(--m-4);
  font-size: var(--m-fs-caption);
}

html.m-app .settings-privacy-footer i { display: none; }

html.m-app .settings-theme-note {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
  margin-top: var(--m-2);
}

/* ════════════════════════════════════════════════════════════════════════
   Support chat launcher

   The launcher keeps its original design: a vertical tab pinned to the right
   edge at mid-height, with the label set in \`writing-mode: vertical-rl\`.

   An earlier pass here replaced it with a circular FAB above the bottom nav,
   on the assumption the tab was being clipped. It wasn't — it sits at
   \`top: 50%\`, nowhere near the nav, and the tab is the established shape for
   this app on every surface. Nothing is overridden now; only the panel it
   opens is adapted below, which is a genuine difference between a phone and
   a desktop window.
   ════════════════════════════════════════════════════════════════════════ */

/* The chat panel itself is a sheet, not a floating desktop window. */
/* replaced below -- see the Support chat section */

html.m-app .chat-widget-header {
  min-height: var(--m-control);
  padding: var(--m-3) var(--m-gutter);
}

html.m-app .chat-widget-header-title {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-semibold);
}

html.m-app .chat-widget-input-row {
  gap: var(--m-2);
  padding: var(--m-3) var(--m-gutter);
  padding-bottom: calc(var(--m-3) + var(--m-safe-bottom));
  border-top: 1px solid var(--m-hairline);
}

html.m-app .chat-widget-msg {
  font-size: var(--m-fs-body);
  line-height: var(--m-lh-body);
  padding: var(--m-2) var(--m-3);
  border-radius: var(--m-r-sm);
}

/* ════════════════════════════════════════════════════════════════════════
   Footer

   A five-column sitemap with newsletter signup and payment marks is a
   desktop artifact — inside the app it's dead weight below the bottom nav.
   On mobile web it collapses to accordions; in the packaged app it goes.
   Third-party brand marks keep their own colours, as on the web.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .ftr-grid,
html.m-app .footer-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
}

html.m-app .ftr-col,
html.m-app .footer-col {
  border-bottom: 1px solid color-mix(in srgb, var(--color-brand-white) 12%, transparent);
  padding: var(--m-2) 0;
}

html.m-app :is(.ftr-col h3, .footer-col h3, .ftr-col-title) {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  /* Permanently-navy surface: these tokens never flip with the theme. */
  color: var(--color-on-navy);
  margin: 0;
  min-height: var(--m-touch);
  display: flex;
  align-items: center;
}

html.m-app :is(.ftr-col a, .footer-col a) {
  display: flex;
  align-items: center;
  min-height: var(--m-touch);
  font-size: var(--m-fs-secondary);
  color: var(--color-on-navy-secondary);
}

html.m-app .ftr-bottom,
html.m-app .footer-bottom {
  flex-direction: column;
  gap: var(--m-3);
  text-align: center;
  font-size: var(--m-fs-caption);
  color: var(--color-on-navy-muted);
  padding: var(--m-4) var(--m-gutter);
  padding-bottom: calc(var(--m-4) + var(--m-bottomnav-total));
}

/* Five link columns, legal links and payment marks are a website structure. In
   an installed app -- packaged or PWA -- that content is either unreachable or
   already in the bottom nav and account sheet, and it added a long scroll of
   links under every page.
   .m-installed carries the \`.m-app\` condition, so a PWA installed on a desktop
   (wide window, no bottom nav) keeps its footer rather than losing its only
   navigation. */
html.m-installed .site-footer,
html.m-installed .ftr-root,
html.m-installed footer.ftr {
  display: none;
}


/* ════════════════════════════════════════════════════════════════════════
   Cart page header

   Its own component (.cart-page-header), not SubPageHeader, and it shipped
   both a back arrow and a close ✕ — two controls that do the same thing,
   at opposite ends of the bar. Back is the one that matches the platform,
   so the ✕ goes and the bar becomes a standard app bar.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .cart-page-header {
  position: sticky;
  top: 0;
  z-index: 120;
  padding-top: var(--m-safe-top);
  background: var(--m-surface-bar);
  border-bottom: 1px solid var(--m-hairline);
  box-shadow: none;
}

html.m-app .cph-inner {
  display: flex;
  align-items: center;
  gap: var(--m-1);
  min-height: var(--m-appbar);
  max-width: none;
  padding: 0 var(--m-2) 0 var(--m-1);
}

html.m-app .cph-back {
  width: var(--m-touch);
  height: var(--m-touch);
  min-width: var(--m-touch);
  padding: 0;
  border: none;
  border-radius: var(--m-r-pill);
  background: transparent;
  color: var(--color-text-primary);
  flex: 0 0 auto;
}

html.m-app .cph-back:active { background: var(--color-surface-hover); }

html.m-app .cph-title {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 1.0625rem;
  font-weight: var(--m-fw-semibold);
  letter-spacing: var(--m-track-title);
  margin: 0;
  padding-left: var(--m-1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

html.m-app .cph-close { display: none; }

/* ════════════════════════════════════════════════════════════════════════
   Order history header

   "Export Orders" is a power-user action that was sharing the title row
   with equal visual weight. It steps down to a tertiary control so the
   screen has one obvious subject — the orders themselves.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .oh-export-btn {
  min-height: 36px;
  padding: 0 var(--m-3);
  border: 1px solid var(--m-hairline-strong);
  border-radius: var(--m-r-pill);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-medium);
  gap: var(--m-1);
  white-space: nowrap;
}

html.m-app .oh-export-btn svg { width: var(--m-icon-sm); height: var(--m-icon-sm); }

/* The date filter sits beside the search field; it needs enough room for
   its longest option plus the caret, or "All Time" clips mid-word. */
html.m-app .oh-date-select,
html.m-app .oh-filter-right select {
  flex: 0 0 auto;
  width: auto;
  min-width: 108px;
  height: var(--m-touch);
  min-height: var(--m-touch);
  padding: 0 var(--m-6) 0 var(--m-3);
  border-radius: var(--m-r-pill);
  font-size: var(--m-fs-secondary);
}

html.m-app .oh-filter-right {
  flex: 0 0 auto;
  gap: var(--m-2);
}

/* Nothing in this layer should render text below the 11px caption size. */
html.m-app .sr-progress-label {
  font-size: var(--m-fs-caption);
}

/* ════════════════════════════════════════════════════════════════════════
   Frequently Bought Together

   The desktop layout runs the bundle horizontally — three narrow cards
   separated by "+" and "=" signs, ending in a total column. On a 360px
   screen that collapses into a column of cramped tiles with the maths signs
   stranded down the left edge.

   Mobile turns each product into a full-width row — checkbox, thumbnail,
   then a name / rating / price stack — with the "+" as a connector badge
   between rows, a summary card for the totals, and one primary action.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .pdp-fbt {
  margin: 0 var(--m-gutter) var(--m-4);
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
}

html.m-app .pdp-fbt-head {
  margin-bottom: var(--m-3);
}

html.m-app .pdp-fbt .pdp-section-h2 {
  font-size: var(--m-fs-page-title);
  font-weight: var(--m-fw-bold);
  letter-spacing: var(--m-track-title);
  margin: 0 0 2px;
}

html.m-app .pdp-fbt-sub {
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
  margin: 0;
}

/* The list: the horizontal flex row becomes a stack. */
html.m-app .pdp-fbt-row {
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: stretch;
  flex-wrap: nowrap;
  padding: 0;
  border: none;
  background: transparent;
}

html.m-app .pdp-fbt-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
}

/* "+" between rows: a circular badge on the leading edge with a hairline
   running through it, so three products read as one bundle rather than
   three unrelated cards. */
html.m-app .pdp-fbt-plus {
  position: relative;
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin: var(--m-1) 0 var(--m-1) var(--m-4);
  border: 1px solid var(--m-hairline);
  border-radius: var(--m-r-pill);
  background: var(--m-surface-card);
  color: var(--color-text-secondary);
  font-size: var(--m-fs-body);
  line-height: 1;
  z-index: 1;
}

html.m-app .pdp-fbt-plus::before {
  content: '';
  position: absolute;
  left: 50%;
  top: -8px;
  bottom: -8px;
  width: 1px;
  margin-left: -0.5px;
  background: var(--m-hairline);
  z-index: -1;
}

/* Each product: one full-width row. */
html.m-app .pdp-fbt-card {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  width: 100%;
  padding: var(--m-3);
  border: 1px solid var(--m-hairline);
  border-radius: var(--m-r);
  background: var(--m-surface-card);
  box-shadow: var(--m-shadow-sm);
  text-align: left;
}

/* An unticked item stays legible but visibly out of the bundle. The empty
   checkbox is what actually states it; the dimming only reinforces, so the
   meaning never rests on opacity alone. */
html.m-app .pdp-fbt-card-off {
  opacity: 0.55;
  box-shadow: none;
}

/* Checkbox. The native input stays in the DOM and operable — moved
   off-screen rather than display:none — so it keeps its role, its label
   association and keyboard focus; the adjacent span draws the box. */
html.m-app .pdp-fbt-check {
  position: relative;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Padding cancelled by negative margin grows the tap area to the 44px
     floor without making the row any taller. */
  padding: 11px;
  margin: -11px 0 -11px -11px;
  cursor: pointer;
}

html.m-app .pdp-fbt-check input {
  position: absolute;
  width: 1px;
  height: 1px;
  min-height: 0;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

html.m-app .pdp-fbt-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 2px solid var(--m-hairline-strong);
  border-radius: var(--m-r-xs);
  background: var(--m-surface-card);
  color: transparent;
  transition: background-color var(--m-dur-fast) var(--m-ease),
              border-color var(--m-dur-fast) var(--m-ease);
}

html.m-app .pdp-fbt-check input:checked + .pdp-fbt-box {
  background: var(--color-secondary);
  border-color: var(--color-secondary);
  /* Navy on blue, matching every other filled control in the system. */
  color: var(--color-text-on-secondary);
}

html.m-app .pdp-fbt-check input:focus-visible + .pdp-fbt-box {
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

html.m-app .pdp-fbt-img {
  flex: 0 0 auto;
  width: 64px;
  height: 64px;
  border-radius: var(--m-r-sm);
  object-fit: cover;
  background: var(--m-surface-sunken);
}

html.m-app .pdp-fbt-info {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

html.m-app .pdp-fbt-name {
  margin: 0;
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
}

html.m-app .pdp-fbt-name .pcard-title-link {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
}

html.m-app .pdp-fbt-rating-row {
  margin: 0;
  gap: var(--m-1);
}

html.m-app .pdp-fbt-price {
  margin: 0;
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-bold);
  font-variant-numeric: tabular-nums;
}

/* ── Summary card ───────────────────────────────────────────────────────── */
html.m-app .pdp-fbt-summary {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  margin-top: var(--m-4);
  padding: var(--m-4);
  border: 1px solid var(--m-hairline);
  border-radius: var(--m-r);
  background: var(--m-surface-card);
}

html.m-app .pdp-fbt-summary-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--m-r-pill);
  background: var(--color-primary-soft);
  color: var(--color-primary);
}

html.m-app .pdp-fbt-total-col {
  flex: 1 1 auto;
  min-width: 0;
  display: block;
  padding: 0;
  border: none;
  background: transparent;
}

html.m-app .pdp-fbt-save-col {
  flex: 0 0 auto;
  text-align: right;
  padding-left: var(--m-3);
  border-left: 1px solid var(--m-hairline);
}

html.m-app .pdp-fbt-total-label {
  margin: 0;
  font-size: var(--m-fs-label);
  font-weight: var(--m-fw-medium);
  color: var(--color-text-secondary);
}

html.m-app .pdp-fbt-total-val {
  margin: 0;
  font-size: 1.25rem;
  font-weight: var(--m-fw-bold);
  line-height: 1.2;
  letter-spacing: var(--m-track-title);
  font-variant-numeric: tabular-nums;
}

/* Savings in orange. The reference shows green, but green in this system is
   reserved for product ratings and is explicitly excluded from discounts;
   orange is the promotion colour. The !important beats the component's
   inline style={{ color: BLUE }}. Swap this one declaration if the brand
   rule changes. */
html.m-app .pdp-fbt-save {
  margin: 0;
  font-size: 1.25rem;
  font-weight: var(--m-fw-bold);
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  color: var(--color-primary) !important;
}

/* "=" is a horizontal-layout device; a stacked list has no use for it. */
html.m-app .pdp-fbt-eq {
  display: none;
}

/* ── Primary action ─────────────────────────────────────────────────────── */
html.m-app .pdp-fbt-add-all {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--m-2);
  width: 100%;
  min-height: var(--m-control-lg);
  margin-top: var(--m-3);
  padding: 0 var(--m-4);
  border: none;
  border-radius: var(--m-r-sm);
  background: var(--color-primary);
  /* Navy on orange is 7.4:1; white would be 2.8:1. */
  color: var(--color-text-on-primary);
  font-size: 1rem;
  font-weight: var(--m-fw-semibold);
  white-space: nowrap;
}

html.m-app .pdp-fbt-add-all:disabled {
  opacity: 0.45;
}

/* ── FBT: overriding the desktop row's own geometry ─────────────────────
   The base card is \`display:flex; flex-direction:column; align-items:center;
   width:148px\` — a narrow vertical tile. Setting \`display:flex\` alone left
   the column direction in place, so the mobile row still stacked its
   checkbox, image and text on top of each other. Every property that
   defines the tile has to be answered, not just the display mode. */
html.m-app .pdp-fbt-card {
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: var(--m-3);
}

/* 92px with 6px of padding and object-fit:contain is sized for the tile. */
html.m-app .pdp-fbt-img {
  width: 64px;
  height: 64px;
  padding: 0;
  object-fit: cover;
}

/* The tile centres its copy; a row reads left-aligned. */
html.m-app .pdp-fbt-name {
  text-align: left;
  color: var(--color-text-primary);
  display: block;
  -webkit-line-clamp: none;
}

html.m-app .pdp-fbt-rating-row {
  justify-content: flex-start;
}

/* \`margin-left: auto\` pushed the totals to the far end of the desktop flex
   row; inside the summary card it just strands them. */
html.m-app .pdp-fbt-total-col {
  margin-left: 0;
  align-items: flex-start;
}

/* The base button is a blue gradient with a blue glow, sized for a desktop
   row. Orange is the commercial action colour, and a heavy drop shadow
   under a full-width button reads as two stacked layers on a phone. */
html.m-app .pdp-fbt-add-all {
  background: var(--color-primary);
  box-shadow: none;
  padding: 0 var(--m-4);
}

html.m-app .pdp-fbt-add-all:hover {
  background: var(--color-primary);
  transform: none;
}

/* ════════════════════════════════════════════════════════════════════════
   Support chat — collapsible edge tab

   The launcher is persistent chrome on every screen, so the only honest way
   to keep it from covering products is to make it genuinely small. It sits
   flush to the right edge, vertically centred, 30px wide — a strip, not a
   button — carrying an icon, the label and a chevron pointing at the edge
   the panel comes from.

   Notes on the mechanics:

   · \`position: fixed\` keeps it put through scrolling, and centring on the
     viewport means it only ever overlaps a ~120px band in the middle of the
     right edge rather than sitting over the thumb zone.
   · A fixed <button> does not block page scrolling — a touch that starts on
     it and drags still scrolls the page — so nothing here interferes with
     scrolling a product grid underneath. \`touch-action: manipulation\` only
     removes the double-tap-zoom delay so the tap registers immediately.
   · Hover is gated behind \`(hover: hover)\`. On a touch screen :hover sticks
     after a tap until you tap elsewhere, which would leave the tab stuck in
     its slid-out state.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .chat-side-tab {
  position: fixed;
  right: 0;
  top: 50%;
  left: auto;
  bottom: auto;
  z-index: 180;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--m-1);

  /* 30px, down from 44. Narrow enough to read as an edge affordance rather
     than a floating control parked on the content. */
  width: 30px;
  min-width: 0;
  min-height: 0;
  padding: var(--m-3) 0;

  border: none;
  /* Rounded on the leading side only, so it reads as attached to the edge. */
  border-radius: var(--m-r) 0 0 var(--m-r);
  background: var(--color-secondary);
  /* Navy on blue: 5.6:1. White would be 3.1:1 and fail AA. */
  color: var(--color-text-on-secondary);
  box-shadow: -2px 0 10px rgba(1, 13, 33, 0.18);

  touch-action: manipulation;
  transform: translateY(-50%);
  transition: transform var(--m-dur) var(--m-ease),
              box-shadow var(--m-dur) var(--m-ease);
}

/* The base rule animates \`padding-right\` on hover/active to nudge the tab
   out. That reflows its contents; translating the whole tab is smoother and
   composites on the GPU. Neutralise both. */
html.m-app .chat-side-tab:hover,
html.m-app .chat-side-tab:active {
  padding-right: 0;
}

@media (hover: hover) {
  html.m-app .chat-side-tab:hover {
    transform: translateY(-50%) translateX(-4px);
    box-shadow: -6px 0 18px rgba(1, 13, 33, 0.26);
  }
}

html.m-app .chat-side-tab:active {
  transform: translateY(-50%) translateX(-2px);
}

html.m-app .chat-side-tab:focus-visible {
  outline: 2px solid var(--color-secondary);
  outline-offset: 2px;
}

html.m-app .chat-side-tab > svg {
  flex: 0 0 auto;
}

html.m-app .chat-side-tab-label {
  writing-mode: vertical-rl;
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-semibold);
  letter-spacing: 0.04em;
  line-height: 1;
}

/* IconChevronDown rotated a quarter turn points at the right edge, i.e. the
   direction the panel slides from. Slightly held back so the icon and label
   stay the primary marks. */
html.m-app .chat-side-tab-chevron {
  display: inline-flex;
  transform: rotate(90deg);
  opacity: 0.7;
}

@media (prefers-reduced-motion: reduce) {
  html.m-app .chat-side-tab {
    transition: none;
  }
}

/* ── The panel it opens ─────────────────────────────────────────────────
   .chat-widget-panel is the window; .chat-widget-body is the scrolling
   message list inside it. An earlier pass here pinned the *body* to the
   viewport, which detached the message list from its own header and input
   row. The sheet treatment belongs on the panel. */
html.m-app .chat-widget-wrap {
  position: fixed;
  inset: 0;
  z-index: 260;
  display: flex;
  /* The base rule is \`flex-direction: column\`, where align-items controls the
     HORIZONTAL axis and justify-content the vertical one. Overriding only
     align/justify without restating the direction centred the panel and left
     a 54px band of page showing beneath it. State all three. */
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
  background: var(--color-overlay);
}

html.m-app .chat-widget-panel {
  width: 100%;
  max-width: none;
  height: 86vh;
  border: none;
  border-radius: var(--m-r-lg) var(--m-r-lg) 0 0;
  padding-bottom: var(--m-safe-bottom);
  box-shadow: var(--m-shadow-sheet);
  animation: m-sheet-up var(--m-dur-sheet) var(--m-ease);
}

@media (prefers-reduced-motion: reduce) {
  html.m-app .chat-widget-panel { animation: none; }
}

html.m-app .chat-widget-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: var(--m-3) var(--m-gutter);
}

/* ════════════════════════════════════════════════════════════════════════
   Card rails: closer to the edge

   Product cards were sitting 24px from the screen edge, not the 16px gutter
   this layer defines — .shop-main contributes 8px of its own padding and
   .pcard-grid adds 16px on top, and the two stack. On a 390px screen that
   is 48px of the width gone to margins before any product is drawn.

   Cards are images first: the wider they are, the more of the product you
   can actually see. So the two paddings are collapsed into one and the rail
   gutter drops to 10px, applied through a token of its own rather than by
   changing --m-gutter — body copy, forms and list rows still want the
   roomier 16px, and only the card rails should move.

   Effect per card, at the three common widths:
     360px:  150 -> 165     390px:  165 -> 180     430px:  185 -> 200
   ════════════════════════════════════════════════════════════════════════ */

html.m-app {
  /* Kept as its own name because a rail means something specific by it --
     the edge a card sits on, and the point a bleeding rail returns to --
     but it resolves to the page gutter so the two cannot drift apart. */
  --m-gutter-cards: var(--m-gutter);
}

/* The outer container carries the gutter, so the heading, the sort toolbar
   and the grid inside it all align to the same edge. */
html.m-app .shop-main {
  padding-left: var(--m-gutter-cards);
  padding-right: var(--m-gutter-cards);
}

/* ...and the grid adds none of its own, which is what removes the doubling. */
html.m-app .pcard-grid {
  padding-left: 0;
  padding-right: 0;
  gap: var(--m-gutter-cards);
}

/* Horizontal rails bleed to the screen edges: their first and last card sit
   on the gutter, and anything mid-scroll runs to the edge, which is what
   makes a rail read as continuing past the screen rather than stopping. */
html.m-app .cat-carousel-track,
html.m-app .carousel-track,
html.m-app .mtb-recent-strip {
  padding-inline: var(--m-gutter-cards);
}

/* 8px, not the 10px gutter: this is the same column gap "Great finds for
   you" uses, and the rail's cards are sized to the same third-of-the-width
   column. Matching both is what makes a rail card land directly above a
   grid card rather than a pixel or two out. */
html.m-app .cat-carousel-track {
  gap: var(--m-2);
}

/* The section headers above those rails keep their own 16px so the label
   sits slightly inboard of the cards it introduces — aligning type to the
   very edge reads as an accident rather than a decision. */

/* ════════════════════════════════════════════════════════════════════════
   Product page: promotional flags removed

   The page carried four badges: "NEW ARRIVAL" over the image, and a row of
   "#1 Best Seller in <category>", "Trending" and "Verified Seller". Hidden
   on mobile at the customer's request.

   Note that "Verified Seller" is in that group. It is a trust signal rather
   than a promotional flag, but it lives in the same .pdp-badges-row and was
   covered by "any other flags" -- deleting the row's rule is one line if it
   should come back.

   The "1 / 3" image counter is deliberately kept: it states how many photos
   exist, which is navigation, not promotion.

   This is display:none in the mobile layer rather than a change to the JSX,
   so the desktop product page is unaffected. Say the word if they should go
   everywhere and I will take them out of the component.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .pdp-img-badge,
html.m-app .pdp-badges-row {
  display: none;
}

/* ════════════════════════════════════════════════════════════════════════
   Product page: description and "You May Also Like" were full-bleed

   Both sections sat at left:0 / right:360 with no horizontal padding of
   their own, so their card borders, text and buttons ran flush into both
   screen edges -- the "Add to Cart" button in a related card was visibly
   cut off at the right.

   Two separate causes:

   · .pdp-tabs-section and .pdp-related have no gutter. Everything else on
     this page is inset by the page's own padding; these two are not.
   · .pdp-related-grid is \`repeat(auto-fill, minmax(190px, 1fr))\`. At 360px
     two 190px tracks do not fit, so auto-fill collapses to a single column
     and every related product became a full-width card taller than half the
     screen.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .pdp-related,
html.m-app .pdp-tabs-section {
  margin-left: var(--m-gutter-cards);
  margin-right: var(--m-gutter-cards);
}

/* Two up, matching the main product grid, so a related product reads as the
   same kind of object as one in the storefront. */
html.m-app .pdp-related-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--m-gutter-cards);
}

html.m-app .pdp-related-card {
  border-radius: var(--m-r);
  box-shadow: var(--m-shadow-sm);
}

html.m-app .pdp-related-card:hover {
  transform: none;
  box-shadow: var(--m-shadow-sm);
}

html.m-app .pdp-related-card img {
  aspect-ratio: 1 / 1;
  height: auto;
  object-fit: cover;
}

html.m-app .pdp-related-body {
  padding: var(--m-3);
  gap: var(--m-1);
}

html.m-app .pdp-related-body h4 {
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}

html.m-app .pdp-related-price {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-bold);
  font-variant-numeric: tabular-nums;
}

html.m-app .pdp-related-original {
  font-size: var(--m-fs-caption);
}

html.m-app :is(.pdp-related-seller, .pdp-related-stock-row) {
  font-size: var(--m-fs-caption);
}

/* The description panel: desktop padding of 22px/26px inside a box that is
   itself now inset. */
html.m-app .pdp-tab-body {
  padding: var(--m-4);
  border-radius: 0 0 var(--m-r) var(--m-r);
  box-shadow: var(--m-shadow-sm);
}

html.m-app .pdp-tab-desc p {
  font-size: var(--m-fs-body);
  line-height: var(--m-lh-body);
  margin-bottom: var(--m-3);
}

html.m-app .pdp-tab {
  font-size: var(--m-fs-secondary);
  padding: var(--m-3) var(--m-3);
  white-space: nowrap;
}

html.m-app .pdp-related .pdp-section-h2 {
  padding-left: 0;
  padding-right: 0;
}

/* The category overline above the product title ("— CLOTHING"). Removed on
   mobile: the category is already reachable from the breadcrumb-free app bar
   and the category rail, and on a narrow screen it pushes the product name --
   the thing the shopper actually came for -- further down the fold. */
html.m-app .pdp-cat-label {
  display: none;
}

/* ════════════════════════════════════════════════════════════════════════
   Checkout — address selection

   The address book's own cards (.ab-*) are reused inside checkout. They are
   built for a two-column desktop grid: 20px padding, a 38px icon disc and
   48px-tall info rows, which comes to 205px per card. On a 360px screen
   that is barely one and a half addresses per viewport, so choosing between
   three means scrolling past the thing you are trying to compare.

   Tightened to roughly 120px, which puts three on screen at once. Nothing
   is removed -- name, icon, street, city, phone, email and the selected
   tick are all still there, just at phone measure.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .ab-cards-grid {
  display: flex;
  flex-direction: column;
  gap: var(--m-3);
}

html.m-app .ab-card {
  padding: var(--m-3);
  border-width: 1px;
  border-radius: var(--m-r);
  box-shadow: var(--m-shadow-sm);
  gap: var(--m-2);
}

html.m-app .ab-card-top {
  gap: var(--m-2);
  align-items: center;
}

html.m-app .ab-card-icon-wrap {
  width: 32px;
  height: 32px;
  min-width: 32px;
  flex: 0 0 auto;
}

html.m-app .ab-card-icon-wrap svg {
  width: var(--m-icon-sm);
  height: var(--m-icon-sm);
}

html.m-app .ab-card-name {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
}

html.m-app .ab-selected-check {
  width: 22px;
  height: 22px;
  min-width: 22px;
  flex: 0 0 auto;
}

html.m-app .ab-card-info {
  display: flex;
  flex-direction: column;
  gap: var(--m-1);
}

/* 48px per row was the biggest single cost: three of them is 144px of a
   205px card. The row now takes the height of its own text. */
html.m-app .ab-info-row {
  align-items: flex-start;
  gap: var(--m-2);
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
}

html.m-app .ab-info-icon {
  flex: 0 0 auto;
  margin-top: 1px;
}

html.m-app .ab-info-icon svg {
  width: 14px;
  height: 14px;
}

/* ── The stepper ────────────────────────────────────────────────────────
   56px circles and 18px labels take 290px before any checkout content --
   more than a third of the screen, on all three steps. */
html.m-app .checkout-steps {
  padding: var(--m-3) var(--m-gutter);
  gap: var(--m-1);
}

html.m-app .step-number {
  width: 26px;
  height: 26px;
  min-width: 26px;
  font-size: var(--m-fs-caption);
}

html.m-app .step-label {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-medium);
}

/* ════════════════════════════════════════════════════════════════════════
   Checkout — payment method

   The card lays out radio | icon | title+blurb | "Selected" chip in a
   single flex row. That works at the width the design was drawn at; at
   360px the text column collapses to about 150px, wrapping "Cash on
   Delivery" onto two lines and the blurb onto eight, and the card grows
   past 800px tall.

   On mobile it becomes two rows: the radio, the icon and the copy across
   the top, and the "Selected" chip beneath. Every element is the one the
   design calls for -- they just stop competing for the same 360px.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .payment-method-card {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  align-items: center;
  gap: var(--m-2) var(--m-3);
  padding: var(--m-3);
  border-radius: var(--m-r);
  min-height: 0;
}

/* The confirmation card is not the three-column chooser above, and must not be
   laid out by counting children.
 *
 * It was. A grid puts each child in the next column, so when a fourth --
 * .co-cod-features, three reassurance labels -- was added to the card, it
 * landed in column 1, sized that \`auto\` track to its own width, and left the
 * copy track (minmax(0, 1fr)) at zero. Measured at a 368px viewport: the title
 * computed to width 0 against a scrollWidth of 72, so "Cash on Delivery" set
 * one character per line down a card 816px tall.
 *
 * Stated as its own row so the layout follows what the card IS -- marker, name,
 * chip -- rather than how many children it happens to have. */
/* flex-wrap, so a label that will not fit costs the CHIP its place on the line
   rather than breaking itself in half.
 *
 * Flex breaks lines on each item's hypothetical size -- for these, their
 * content width -- before any growing or shrinking happens. Measured at a
 * 368px viewport, 284px of usable card:
 *
 *   "Cash on Delivery"  26 + 12 + 139 + 12 + 87 = 276  <= 284, one line
 *   "MTN Mobile Money"  26 + 12 + 159 + 12 + 87 = 296  >  284, chip drops
 *
 * so the short label keeps the single-line card the design asks for, and the
 * long one keeps its name whole on line one with the chip beneath. Without
 * this the title took the squeeze instead: "MTN Mobile Money" had 147px for
 * the 159px it needs and wrapped to two lines, making that card 76px against
 * the other's 53px.
 *
 * Chasing the 12px difference in padding and gaps was the alternative and it
 * is not worth having: it would just move the cliff to the next label, and
 * these come from the payment provider (backend/utils/payments), not from us. */
html.m-app .payment-method-card.co-selected,
html.m-app .payment-method-card.co-choice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--m-3);
  min-height: 0;
}

/* The base sizes this marker to 26px for the confirmation card, but the
   generic m-app .co-radio rule pins width/height AND their min- twins at 18px,
   so it has to be restated here or the disc comes back squashed. */
html.m-app .payment-method-card.co-selected .co-radio,
html.m-app .payment-method-card.co-choice .co-radio {
  width: 26px;
  height: 26px;
  min-width: 26px;
  min-height: 26px;
}

/* Body size, not card-title size, and the one place in this file where that is
   a fitting decision rather than a typographic one.
 *
 * --m-fs-card-title is 1rem, and rem here is the mobile layer's 18px root, so
 * it renders at 18px rather than the 16px its token comment describes. At 18px
 * "Cash on Delivery" measured 148px against 147px of free width -- one pixel
 * short, so it wrapped to two lines and the clean single-row card became two.
 *
 * --m-fs-body is 0.9375rem, about 16.9px here, which brings the title to ~139px
 * and leaves 8px in hand. That margin is the point: French renders this string
 * as "Paiement à la livraison" and Swahili as "Lipa Unapopokea", so a layout
 * that only just fits the English is one translation away from wrapping again.
 * Longer locales still wrap -- they simply do it without anything breaking. */
html.m-app .co-selected-title {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
}

/* The .payment-method-icon and .payment-method-info rules that stood here are
   gone with the markup -- see the note in App.css. The card's type is now
   .co-selected-title, defined just above. */

/* Sits at the far end of the same row as the title. It used to be dropped onto
   a row of its own (grid-column: 1 / -1) to stop it stealing width from the
   title and wrapping "Cash on Delivery" -- with the blurb and the reassurances
   gone there is room for both, and the card reads as a single line. */
html.m-app .co-selected-chip {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: var(--m-1);
  height: 26px;
  padding: 0 var(--m-2);
  border-radius: var(--m-r-pill);
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-semibold);
  white-space: nowrap;
}

html.m-app .co-panel-title {
  font-size: var(--m-fs-section);
  font-weight: var(--m-fw-semibold);
  letter-spacing: var(--m-track-title);
}

html.m-app .co-protection-note {
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  gap: var(--m-2);
}

/* ── Order notes ────────────────────────────────────────────────────────── */
html.m-app .co-optional {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-regular);
  color: var(--color-text-muted);
}

/* ════════════════════════════════════════════════════════════════════════
   Checkout — the forward action

   Continue to Payment / Place Order carry the step forward, so they get the
   full width and the taller control height, and sit on brand blue with navy
   text. White on #3B82F6 is 3.1:1 and fails AA; navy on it is 5.6:1, which
   is the rule the rest of the system already follows for filled controls.
   ════════════════════════════════════════════════════════════════════════ */

/* .btn-place-order carries both "Continue to Payment" and "Place Order".
   (Two other class names were listed here previously -- .co-continue-btn and
   .co-next-btn -- which exist nowhere in the app. They were guessed rather
   than checked, and their presence made the rule look like it covered more
   than it did.)

   The base rule sets \`background: linear-gradient(...)\` and \`color: white\`.
   An earlier version of this block set neither, so the comment claimed navy
   on blue while the button carried on rendering white on blue -- which is
   3.1:1 and fails AA. Both are now actually declared. */
html.m-app :is(.btn-place-order, .cs-checkout-btn) {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--m-2);
  width: 100%;
  min-height: var(--m-control-lg);
  margin-top: var(--m-4);
  padding: 0 var(--m-4);
  border: none;
  border-radius: var(--m-r-sm);
  /* Flat, not a gradient: a gradient across a full-width button reads as a
     banner rather than a control at this size. */
  background: var(--color-secondary);
  /* Navy on #3B82F6 is 5.6:1. White is 3.1:1. */
  color: var(--color-text-on-secondary);
  font-size: 1rem;
  font-weight: var(--m-fw-semibold);
  white-space: nowrap;
}

html.m-app :is(.btn-place-order, .cs-checkout-btn):hover:not(:disabled),
html.m-app :is(.btn-place-order, .cs-checkout-btn):active:not(:disabled) {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
}

/* .cs-checkout-btn is the cart's "Proceed to Checkout" -- the first of the
   three forward actions in the purchase flow, the other two being
   "Continue to Payment" and "Place Order" (both .btn-place-order).
   It was the odd one out: 44px rather than 52, 14.7px/700 rather than
   16px/600, a 12px radius rather than 10, and a background from a color-mix
   that landed a shade off the brand blue. Three steps of one flow should
   not each present a differently-shaped primary button, so it shares the
   rule above rather than carrying its own copy of the values -- that way
   they cannot drift apart later. */

html.m-app .co-under-cta {
  font-size: var(--m-fs-caption);
  color: var(--color-text-secondary);
  text-align: center;
  margin: var(--m-2) 0 0;
}

/* The COD confirmation card is followed by ~100px of dead space before
   "Order notes", inherited from desktop spacing between payment options. */
html.m-app .payment-method-cod-confirm {
  margin-bottom: var(--m-4);
}

html.m-app .cod-payment-section > * + * {
  margin-top: var(--m-4);
}

/* ════════════════════════════════════════════════════════════════════════
   Order progress tracker: horizontal rail → vertical timeline

   The desktop tracker lays five steps left to right, each sized to its own
   content with dashed connectors absorbing the slack between. That works
   across ~700px. On a 360px phone the card's inner width is about 296px, so
   each step gets roughly 59px -- narrower than the words in it. "Order
   Received" broke to "Order / Receive / d", "Seller Processing" to
   "Processin / g", and the timestamps and status pills underneath ended up
   on different baselines from each other.

   A vertical timeline is the shape this wants on a phone: each step gets the
   full width for its label, the dots line up in a single column, and the
   connector becomes the spine running between them. It also reads in the
   order the events actually happen, top to bottom.

   Only the axis changes. Every element -- dot, icon, label, timestamp, the
   "In Progress" pill, and the done/active colouring -- is the one the
   desktop renders.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .order-success-tracker {
  flex-direction: column;
  align-items: stretch;
  padding: var(--m-4);
  border-radius: var(--m-r);
  box-shadow: var(--m-shadow-sm);
  gap: 0;
}

/* Dot in a fixed 32px column, everything else in the rest of the row. */
html.m-app .ost-step {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: center;
  column-gap: var(--m-3);
  row-gap: 2px;
  width: 100%;
  text-align: left;
}

html.m-app .ost-dot {
  grid-row: 1 / span 2;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  min-width: 32px;
}

html.m-app .ost-label {
  grid-column: 2;
  margin: 0;
  font-size: var(--m-fs-body);
  line-height: var(--m-lh-snug);
  /* The wrapping this fixes was mid-word, so let it wrap between words and
     nowhere else. */
  overflow-wrap: normal;
  word-break: normal;
  hyphens: none;
}

/* Timestamp / "Pending" sits directly under its own label rather than in a
   separate row that has to stay aligned with four other columns. */
html.m-app .ost-sub {
  grid-column: 2;
  margin: 0;
  font-size: var(--m-fs-caption);
  line-height: var(--m-lh-snug);
}

html.m-app .ost-pill-active {
  grid-column: 2;
  justify-self: start;
  margin: 2px 0 0;
  font-size: var(--m-fs-caption);
  white-space: nowrap;
}

/* The connector is a sibling of the steps, not a child, so it is positioned
   into the dot column by an indent rather than by nesting. 15px = half of a
   32px dot minus half the 2px line, which puts it exactly on the dots' axis. */
html.m-app .ost-line {
  flex: 0 0 auto;
  width: 2px;
  height: 18px;
  margin: 2px 0 2px 15px;
  /* The dashed pattern is drawn left-to-right for a horizontal rail; rotate
     it so the dashes run down the spine instead of vanishing. */
  background-image: repeating-linear-gradient(
    to bottom,
    var(--border) 0,
    var(--border) 5px,
    transparent 5px,
    transparent 10px
  );
}

html.m-app .ost-line-done {
  background-image: none;
}

/* The mid-word breaking had a specific cause: App.css caps these at
   \`max-width: 80px\` below 820px and \`max-width: 60px\` below 600px, so the
   horizontal rail's five columns would fit. "Order Received" cannot fit in
   60px at any weight, so it broke to "Order / Receive / d".

   In a vertical timeline the label has the whole row, so the cap comes off
   and the text wraps between words if it wraps at all. */
html.m-app .ost-label,
html.m-app .ost-sub {
  max-width: none;
  white-space: normal;
}

/* Restated after the cap is lifted: App.css also drops these to 0.7rem and
   0.66rem below 600px, which is under this layer's 11px floor and was only
   ever a way of squeezing five columns onto one line. */
html.m-app .ost-label {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  margin: 0;
}

html.m-app .ost-sub {
  font-size: var(--m-fs-caption);
}

/* ════════════════════════════════════════════════════════════════════════
   Order confirmation: "Delivering to"

   .order-success-map is decorative -- a 100x90 box filled with a
   repeating-linear-gradient of diagonal stripes and a map glyph. It is not a
   map: no tiles, no coordinates, nothing derived from the address beside it.
   On desktop it sits to the right of the text as a small graphic. On a phone
   .osa-body wraps and it becomes a wide empty striped band above the
   address, which reads as an image that failed to load.

   Nothing is lost by removing it, and roughly 100px of the fold is regained
   for the address itself. (There IS a real map in this app -- the delivery
   tracking page uses react-leaflet with actual coordinates. This is not it.)
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .order-success-map {
  display: none;
}

html.m-app .order-success-cols {
  display: flex;
  flex-direction: column;
  gap: var(--m-3);
}

html.m-app :is(.order-success-address, .order-success-summary) {
  padding: var(--m-4);
  border-radius: var(--m-r);
  box-shadow: var(--m-shadow-sm);
}

html.m-app :is(.order-success-address, .order-success-summary) > h3 {
  display: flex;
  align-items: center;
  gap: var(--m-2);
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-semibold);
  margin: 0 0 var(--m-3);
}

/* The three lines are one address, so they sit as one block rather than
   three paragraphs with 4px of air between them. */
html.m-app .osa-body {
  display: block;
}

html.m-app .osa-info {
  display: flex;
  flex-direction: column;
  gap: var(--m-1);
}

html.m-app .order-success-address p {
  margin: 0;
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
}

/* The name leads, so it gets body size and weight rather than the same
   13px as the street. */
html.m-app .order-success-address p strong {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
}

/* "Change Address" is the card's one action: a real control with a 44px tap
   target, not an underlined run of text. Padding cancelled by an equal
   negative margin so it gains the target without adding height. */
html.m-app .order-success-address .btn-link {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: var(--m-1);
  margin: var(--m-2) 0 0;
  padding: 11px 8px;
  margin-left: -8px;
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-semibold);
  color: var(--color-secondary-text);
  text-decoration: none;
}

/* Order summary rows: label left, figure right, tabular so the column of
   numbers lines up. */
html.m-app .order-success-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--m-3);
  min-height: 28px;
  font-size: var(--m-fs-secondary);
}

html.m-app .order-success-row strong {
  font-variant-numeric: tabular-nums;
}

html.m-app .order-success-row.total {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-bold);
  padding-top: var(--m-2);
}

/* "Continue to Payment" to the same 328px as "Place Order".
 *
 * The two buttons already share one rule and both are width:100%; the
 * difference was their containers. Place Order sits inside
 * .cod-payment-section, a .co-panel with 16px of padding, so it lands at
 * 328px on a 360px screen. Continue to Payment is a direct child of
 * .summary-right, which has none, so it ran the full 360px and was the only
 * thing on that step touching both screen edges.
 *
 * Inset via calc rather than a literal 328px: the number is only correct at
 * one viewport, whereas this holds the same 16px gutter at every width --
 * which is what actually makes it match, on a 360px phone and a 430px one
 * alike.
 *
 * Scoped to the direct child of .summary-right so it cannot reach the
 * step-3 button, which is already inset by its panel and would otherwise be
 * squeezed to 296px.
 */
/* One gutter for the whole step, rather than an inset per element.
 *
 * The first version of this insetted just the button with a calc. That
 * worked for the button and left everything else on the step to its own
 * devices -- the "Secure checkout with Buyer Protection" note came out at
 * 326px/L17 against the button's 328px/L16, close enough to look accidental
 * rather than aligned.
 *
 * The container carries the 16px instead, and its two columns carry none, so
 * every child is plain width:100% and they cannot drift apart. Step 3 is a
 * different container (.checkout-side) and is unaffected -- it already sat
 * at 328/L16 via its own panel. */
html.m-app .order-summary-container {
  padding-left: var(--m-4);
  padding-right: var(--m-4);
  gap: var(--m-3);
}

html.m-app .summary-left,
html.m-app .summary-right {
  padding-left: 0;
  padding-right: 0;
}

html.m-app .summary-right > .co-under-cta {
  padding-left: 0;
  padding-right: 0;
}

/* Now that the container provides the gutter, the note is width:100% like
   everything else beside it. */
html.m-app .co-protection-note {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  padding: var(--m-3);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
}

/* Step 2's note lives INSIDE .summary-left. That used to be a card with a
   1px border, so the note needed to step back out over it to share the
   button's edge. .summary-left is no longer a card on mobile (see below),
   so there is no border to compensate for and the note is plain 100%. */
html.m-app .summary-left > .co-protection-note {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

/* The CTA needs the same correction, and was the one element that missed it.
 *
 * App.css insets Place Order and its two notes by 14px a side, so that on the
 * app's full-bleed checkout they line up with the payable total's inner edge
 * rather than the panel's. This layer takes the opposite approach one level
 * up -- the container owns the gutter and every child is a plain width:100%
 * (see the block at the top of this section) -- and it sets that width on
 * .btn-place-order directly.
 *
 * Those two decisions collide: width:100% is resolved against the column's
 * content box, so App.css's surviving side margins are added OUTSIDE it and
 * the button overhangs its own column by 28px. The notes beside it were
 * already brought back in by the two rules above; the button was not, which
 * is why it alone hung over the edge.
 *
 * Zeroed rather than un-setting the width: the margins are what disagree with
 * this layer, and width:100% is what every other child on the step uses. */
html.m-app :is(.btn-place-order, .cs-checkout-btn) {
  margin-left: 0;
  margin-right: 0;
}

/* .summary-left is a .co-panel -- border, 16px radius, shadow -- wrapping
   two things that are already cards: the "Delivering to" block and the
   order-item rows. On a 360px screen the outer border ends up running
   within a few pixels of the inner cards' own borders, so the two read as
   one doubled, badly-padded line rather than as a card containing cards.
   
   Desktop has room for the nesting to be legible; mobile does not. Here
   the outer panel stops being a surface and becomes just a grouping: the
   heading stays, the chrome goes, and the inner cards carry the edges. */
html.m-app .summary-left.co-panel {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
  box-shadow: none;
}

/* .summary-left is a flex column with gap:20px, so the space between the
   heading, the address block, the items and the note is already uniform --
   it just wasn't visible while every child ALSO carried its own margin,
   which adds to a flex gap rather than collapsing into it. That is what
   made the three gaps 32 / 24 / 38px instead of one step.
   
   The margins go and the gap alone does the spacing. Nothing here sets a
   margin-top for the same reason: it would stack on the gap again. */
html.m-app .summary-left.co-panel > .co-panel-title {
  margin-bottom: 0;
}

html.m-app .summary-left.co-panel > :is(.address-section, .order-items-section, .co-protection-note) {
  margin-top: 0;
  margin-bottom: 0;
}

html.m-app .summary-left .order-items-section > .order-items {
  margin-bottom: 0;
}

/* ════════════════════════════════════════════════════════════════════════
   Order success: the confirmation notice

   Behaves like a toast that lives inline. It says its piece and then
   collapses in place after five seconds rather than sitting there
   permanently restating the heading above it. Collapsing (height, margin and
   opacity to zero) rather than fading alone means nothing below it jumps
   when it goes.

   GREEN, at the customer's request. Worth recording that the design system
   says otherwise: green is scoped to product ratings and the confirm dialog,
   and CLAUDE.md names "success messages" as a case it must NOT be used for,
   because with only four hues a colour cannot carry meaning on its own.

   Two things make this defensible rather than a straight violation. It uses
   --color-confirm-safe, the green the system ALREADY sanctions for the
   confirm dialog, rather than a fifth hue invented here -- so there is still
   exactly one green in the app, with dark-mode variants already tuned. And
   the notice keeps its tick icon and its sentence, so the meaning never
   rests on the hue.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .order-success-trust {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--m-2);
  margin: var(--m-3) 0;
  padding: var(--m-3);
  border: 1px solid color-mix(in srgb, var(--color-confirm-safe) 30%, transparent);
  border-radius: var(--m-r-sm);
  background: var(--color-confirm-safe-soft);
  color: var(--color-confirm-safe);
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
  overflow: hidden;
  transition:
    opacity var(--m-dur) var(--m-ease),
    max-height var(--m-dur-sheet) var(--m-ease),
    margin var(--m-dur-sheet) var(--m-ease),
    padding var(--m-dur-sheet) var(--m-ease),
    border-width var(--m-dur-sheet) var(--m-ease);
  max-height: 200px;
}

html.m-app .order-success-trust svg {
  flex: 0 0 auto;
}

html.m-app .order-success-trust-hidden {
  max-height: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  border-width: 0;
  opacity: 0;
  /* Nothing left to interact with once it has gone. */
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  html.m-app .order-success-trust {
    transition: none;
  }
}

/* ── Follow-up line ─────────────────────────────────────────────────────
   Replaces the "What's Next?" block: a heading, a paragraph restating that
   the seller is preparing the order, and three mini-tiles that were labels
   rather than links. One sentence pointing at where the status actually
   lives does the same job. */
html.m-app .order-success-followup {
  margin: var(--m-4) 0;
  padding: 0 var(--m-gutter-cards);
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-body);
  color: var(--color-text-secondary);
  text-align: center;
}

html.m-app .order-success-followup .btn-link {
  display: inline;
  min-height: 0;
  padding: 0;
  font-size: inherit;
  font-weight: var(--m-fw-semibold);
  color: var(--color-secondary-text);
  text-decoration: underline;
}

/* ════════════════════════════════════════════════════════════════════════
   My Orders: one left edge for the whole page

   .oh-page sits at L20 and pads 16, so its content lands at L36 -- the
   header, the filter bar and the order rows all line up there. The metric
   rail was the exception: data.css bleeds rails to the screen edge with a
   negative inline margin so cards can scroll off it, which put its cards at
   L20, 16px outboard of everything beneath them.

   Bleeding is right for a rail on the storefront, where it runs to the edge
   of the screen. Here it runs to the edge of a padded page and lands on no
   edge in particular, so it just reads as a misalignment. The rail keeps its
   horizontal scrolling and loses the bleed.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .oh-page .oh-stats-grid {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}

/* ── The order card ─────────────────────────────────────────────────────
   Each order is a card: identity at the top, the product in the middle, the
   amount and status at the foot. The labels above each field come from the
   desktop table's column headers, which is right -- but at 11px uppercase
   they were competing with the values they label. */
html.m-app .oh-row-wrap {
  border: 1px solid var(--m-hairline);
  border-radius: var(--m-r);
  background: var(--m-surface-card);
  box-shadow: var(--m-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--m-3);
}

html.m-app .oh-row {
  display: flex;
  flex-direction: column;
  gap: var(--m-2);
  width: 100%;
  padding: var(--m-3);
  border: none;
}

/* A cell is a STACK of label/value pairs, not one pair: .oh-cell-order holds
   "Order ID" + the id + "Placed on" + the date, all as siblings. An earlier
   version here laid the cell out as a row with space-between, which put all
   four on one line and wrapped every one of them ("#ORD- 64153", a date over
   three lines). Column, as the markup intends. */
html.m-app .oh-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  padding: 0;
  border: none;
  text-align: left;
  font-size: var(--m-fs-secondary);
}

html.m-app .oh-cell-label {
  font-size: var(--m-fs-label);
  font-weight: var(--m-fw-medium);
  text-transform: none;
  letter-spacing: 0;
  color: var(--color-text-secondary);
  margin: 0;
}

/* Labels and values are flat siblings with no wrapper per pair, so the
   grouping is made by spacing: a label that follows a value starts a new
   pair and gets air above it; the first one does not. */
html.m-app .oh-cell > * + .oh-cell-label {
  margin-top: var(--m-2);
}

html.m-app .oh-cell > p {
  margin: 0;
}

/* The product is the thing being bought, so it gets the full width and a
   thumbnail rather than a right-aligned value. */
html.m-app .oh-cell-product {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: var(--m-3);
  text-align: left;
  padding: var(--m-3) 0;
  margin: var(--m-1) 0;
  border-top: 1px solid var(--m-hairline);
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .oh-cell-product .oh-cell-label {
  display: none;
}

html.m-app :is(.oh-prod-img, .oh-prod-img-placeholder) {
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: var(--m-r-xs);
  object-fit: cover;
}

html.m-app .oh-prod-info {
  min-width: 0;
  flex: 1 1 auto;
  text-align: left;
}

html.m-app .oh-prod-name {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  line-height: var(--m-lh-snug);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

html.m-app :is(.oh-prod-seller, .oh-prod-qty, .oh-prod-more) {
  font-size: var(--m-fs-caption);
  color: var(--color-text-secondary);
  margin: 0;
}

html.m-app .oh-prod-price {
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-semibold);
  font-variant-numeric: tabular-nums;
  margin: 0;
}

html.m-app .oh-order-id {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  font-variant-numeric: tabular-nums;
}

html.m-app .oh-order-date {
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
}

html.m-app .oh-amount {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-bold);
  font-variant-numeric: tabular-nums;
}

/* Actions sit on their own row at the foot, sharing the width evenly. */
html.m-app .oh-cell-actions {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: var(--m-2);
  padding-top: var(--m-3);
  margin-top: var(--m-1);
  border-top: 1px solid var(--m-hairline);
}

html.m-app .oh-cell-actions .oh-cell-label {
  display: none;
}

html.m-app .oh-cell-actions button {
  flex: 1 1 auto;
  min-height: var(--m-touch);
  padding: 0 var(--m-3);
  border-radius: var(--m-r-xs);
  font-size: var(--m-fs-secondary);
  white-space: nowrap;
}

/* The amount cell carries a payment-state badge: "Paid" once delivered,
   otherwise "COD". The Payment Method row directly beneath already says COD,
   so on an undelivered order the word appeared twice in one card. Only the
   duplicate is hidden -- "Paid" still shows, because that is a state the
   Payment Method row does not tell you. */
html.m-app .oh-cell-amount .oh-cod-badge {
  display: none;
}

/* Status pills sit inline with their label rather than filling the row. */
html.m-app .oh-cell :is(.oh-paid-badge, .oh-status-pill) {
  align-self: flex-start;
  margin-top: var(--m-1);
}

/* ════════════════════════════════════════════════════════════════════════
   One left edge, everywhere

   Every screen should sit on the same gutter as the product rails -- the
   edge "You May Also Like" uses. Setting --m-gutter alone did not achieve
   that, because several pages nest a padded container inside another padded
   one and the two stack: .settings-page and .settings-container both took
   the gutter and landed content at 20px; the orders page stacked three
   levels and landed at 30px.

   So the gutter is applied once, at the OUTERMOST container, and any of
   these wrappers nested inside another gets none. A page cannot then
   accumulate an edge by adding a wrapper.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app :is(
  .settings-page, .settings-container, .dash-page, .oh-page, .wl-page,
  .ntf-page, .ab-page, .pf-page, .cartpg-grid, .checkout-container,
  .legal-page, .about-page, .careers-page, .privacy-page, .cookie-page,
  .order-summary-container
) :is(
  .settings-page, .settings-container, .dash-page, .oh-page, .wl-page,
  .ntf-page, .ab-page, .pf-page, .cartpg-grid, .checkout-container,
  .legal-page, .about-page, .careers-page, .privacy-page, .cookie-page,
  .order-summary-container
) {
  padding-left: 0;
  padding-right: 0;
}

/* The pages that carry their own base padding on top of the layer's gutter.
   Each of these landed 10-20px further in than the rails they sit above. */
html.m-app :is(.oh-page, .wl-page, .pf-page, .legal-page, .about-page) {
  padding-left: var(--m-gutter);
  padding-right: var(--m-gutter);
}

/* Inner cards on the orders and profile pages were adding a second inset of
   their own on top of the page's. */
html.m-app .oh-page > *,
html.m-app .pf-page > * {
  margin-left: 0;
  margin-right: 0;
}

/* Top Sales / Trending / Great finds and the product grid are deliberately
   NOT touched here. They already sit on the reference edge and the customer
   asked for them left alone; this section is only about the navigation
   pages (orders, profile, wishlist, settings, and the info pages). */

/* The wrapper around the account and info pages carried 20px of horizontal
   padding, which is what pushed My Orders, Profile, Wishlist, Notifications
   and the legal pages to a 30px edge while the rails beside them sat at 10.
   It keeps its vertical padding -- only the horizontal half is the layer's
   to decide, and the page inside it supplies that. */
html.m-app .page-shell-pad {
  padding-left: 0;
  padding-right: 0;
}

/* ── Order confirmation: onto the same edge as everything else ──────────── */

/* .order-success-wrap is a centred flex column with no horizontal padding, so
   every width:100% child under it -- the tracker, the items card, the address
   and summary cards, the follow-up line, the recommendations grid -- sat flush
   against the screen at L0, while the cards' own 18px/20px padding put their
   text at L21. Two different edges on one screen, and neither was the 10px the
   rest of the app uses.
   
   The gutter belongs on the wrap rather than on each section: the sections are
   width:100% by design (they are cards), so padding the one container moves all
   of them together and keeps the card padding doing what it should. The
   centred hero, title and icon are unaffected -- align-items:center makes them
   shrink-to-fit, so they stay centred in whatever width the wrap gives them. */
html.m-app .order-success-wrap {
  padding-left: var(--m-gutter);
  padding-right: var(--m-gutter);
}

/* ── Top Sales rail: same page surface as the feed sections ────────────── */

/* The rail sat on a white panel -- .cat-row painted white with 8px of
   padding, .cat-row-inner painted white again with 14px and a 6px radius --
   inside an already-white page. Two nested panels you cannot see, whose only
   visible effect was to push the cards to a 32px edge while "Great finds for
   you" below sat at 10px with no panel at all.
   
   The panel goes. The rail's own padding-inline then puts its cards on the
   same 10px edge as the grid, and the header takes the gutter directly so
   the title lines up with both. */
html.m-app :is(.cat-row, .cat-row-inner) {
  padding-left: 0;
  padding-right: 0;
  background: none;
  border-radius: 0;
  box-shadow: none;
}

html.m-app .cat-row-header {
  padding-left: var(--m-gutter);
  padding-right: var(--m-gutter);
}

/* Cards size to their own content. With the image tile now reliably square
   they all come out the same height anyway, but stretching to the tallest is
   what turned one portrait thumbnail into 350px-tall cards across the rail. */
html.m-app .cat-carousel-track {
  align-items: flex-start;
}

/* ── Hero carousel: the slide contains its own contents ────────────────── */

/* .slide-content stacked a badge, a headline, a subtitle and a 44px CTA
   inside 20/22/18px of padding with 6px gaps: 189px of content in a 185px
   slide. The slide clips (overflow: hidden), so the overflow did not show as
   a spill -- it showed as the CTA and the subtitle being sliced through,
   mid-word and mid-glyph, which is what "not fitting inside the card" looked
   like from the outside.
   
   The fix is on both axes. Vertically: tighter padding and gaps, and a hard
   max-height so the box can never exceed the slide again whatever copy an
   admin types. Horizontally: the text column was capped at 68% of a 299px
   slide, leaving 135px of usable width for a headline -- roughly two words a
   line. 78% is still narrow enough to keep the product visible behind it. */
html.m-app .slide-content {
  /* width, not just max-width: .slide-content is a flex item, so it was
     sizing to its own content (167px) and the 68%/78% cap never came into
     play at all. Claiming the width is what actually gives the headline
     room -- otherwise the copy sets the column and the column stays narrow. */
  width: 78%;
  max-width: 78%;
  max-height: 100%;
  padding: var(--m-4);
  gap: var(--m-1);
  overflow: hidden;
}

/* Long copy now ends in an ellipsis on a line boundary instead of being cut
   through the middle of a letter. Two lines for the headline, one for the
   subtitle: that is what fits above a 44px CTA at this slide height. */
html.m-app .slide-title {
  font-size: var(--m-fs-section);
  line-height: var(--m-lh-snug);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

html.m-app .slide-subtitle {
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/mobile/screens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;6EAU6E;;AAE7E,8EAA8E;AAC9E;EACE,iCAAiC;EACjC;;qCAEmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;gDACgD;AAChD;;;;;;;EAOE,eAAe;EACf,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;;;sEAGsE;AACtE;;;;EAIE,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;;AAEA;;;;;EAKE,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;;;EAIE,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;EAClC,SAAS;AACX;;AAEA;wEACwE;AACxE;EACE,aAAa;AACf;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;6EAE6E;;AAE7E,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,mCAAmC;EACnC,YAAY;EACZ,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EACrB,mCAAmC;EACnC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA,+CAA+C,aAAa,EAAE;;AAE9D;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,+BAA+B,oBAAoB,EAAE,qBAAqB,EAAE;;AAE5E;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB,yBAAyB,uBAAuB,EAAE;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,kDAAkD,aAAa,EAAE;;AAEjE;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA,6BAA6B,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAE3E;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;;;;;;;;;;;kBAYkB;AAClB;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;;EAEE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,kCAAkC;AACpC;;AAEA;;;;2DAI2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC,oBAAoB,EAAE,qBAAqB,EAAE;;AAE7E;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;uEACuE;AACvE;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA,+DAA+D;AAC/D;;EAEE,aAAa;AACf;;AAEA;;;;;;6EAM6E;;AAE7E;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gEAAgE;EAChE,sDAAsD;AACxD;;AAEA;;;;;;yDAMyD;AACzD;EACE,WAAW;EACX,MAAM;EACN,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;;;;;;0CAO0C;AAC1C;EACE,cAAc;EACd,aAAa;EACb;;;;;iEAK+D;EAC/D,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;0BAG0B;AAC1B;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;2EAC2E;AAC3E;;;;sCAIsC;AACtC;EACE,8BAA8B;EAC9B,eAAe;EACf,mCAAmC;EACnC,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,kCAAkC;EAClC,YAAY;AACd;;AAEA;4DAC4D;AAC5D;;EAEE,aAAa;AACf;;AAEA;;EAEE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;;yDAGyD;AACzD;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;iDACiD,aAAa,EAAE;;AAEhE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;;EAEE,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB,KAAK,mDAAmD;EACzE,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;sDAEsD;AACtD;;4CAE4C;AAC5C;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,+CAA+C,aAAa,EAAE;;AAE9D;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;;uDAEuD;AACvD;;;;;EAKE,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;4CAC4C;AAC5C;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;EAC5B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,2BAA2B,2BAA2B,EAAE,+BAA+B,EAAE;AACzF,2BAA2B,8BAA8B,EAAE,kCAAkC,EAAE;AAC/F,4BAA4B,gCAAgC,EAAE,iCAAiC,EAAE,iBAAiB,EAAE;;AAEpH;;;;;;;;;;4DAU4D;AAC5D;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,sDAAsD;EACtD,wDAAwD;EACxD,gCAAgC;EAChC,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE;IACE,qEAAqE;IACrE,0CAA0C;IAC1C,kDAAkD;EACpD;AACF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sCAAsC,cAAc,EAAE;;AAEtD;;4EAE4E;AAC5E;EACE,uBAAuB;EACvB,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iDAAiD;EACjD,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;yEACyE;AACzE;EACE,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gCAAgC,2BAA2B,EAAE,+BAA+B,EAAE;AAC9F,8BAA8B,8BAA8B,EAAE,kCAAkC,EAAE;AAClG,+BAA+B,eAAe,EAAE,qBAAqB,EAAE;AACvE,mCAAmC,oBAAoB,EAAE,qBAAqB,EAAE;;AAEhF;;6EAE6E;;AAE7E;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B,wBAAwB,mBAAmB,EAAE,4BAA4B,EAAE;AAC3E,0BAA0B,gCAAgC,EAAE,iCAAiC,EAAE;AAC/F,wBAAwB,8BAA8B,EAAE;AACxD,0BAA0B,WAAW,EAAE,8BAA8B,EAAE;;AAEvE;iEACiE;AACjE;;EAEE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,4DAA4D;EAC5D,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;iBAEiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;sDAIsD;AACtD;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;;yDAGyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf;;;;;;;mEAOiE;EACjE,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,SAAS;EACT,4BAA4B;EAC5B,+BAA+B;EAC/B,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;;;;6EAI6E;AAC7E;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,0CAA0C;EAC1C,4BAA4B;EAC5B,iCAAiC;EACjC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;6EAE6E;;AAE7E;EACE,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,4BAA4B,2BAA2B,EAAE,+BAA+B,EAAE;AAC1F,8BAA8B,8BAA8B,EAAE,kCAAkC,EAAE;AAClG;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,iDAAiD,aAAa,EAAE;;AAEhE;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mCAAmC;EACnC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA,2BAA2B,2BAA2B,EAAE,iCAAiC,EAAE;AAC3F,4BAA4B,gCAAgC,EAAE,kCAAkC,EAAE,6BAA6B,EAAE;;AAEjI;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,SAAW;EACX,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;oDACoD;AACpD;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,mDAAmD;EACnD,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE,uCAAuC,aAAa,EAAE;;AAEtD;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,wCAAwC,aAAa,EAAE;;AAEvD;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;6EAY6E;;AAE7E,qEAAqE;AACrE,mDAAmD;;AAEnD;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,uDAAuD;EACvD,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;;;;;;6EAO6E;;AAE7E;;EAEE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;;EAEE,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,sEAAsE;EACtE,2BAA2B;EAC3B,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,2DAA2D;AAC7D;;AAEA;;;;;;gBAMgB;AAChB;;;EAGE,aAAa;AACf;;;AAGA;;;;;;;6EAO6E;;AAE7E;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,8BAA8B;EAC9B,gCAAgC;EAChC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,8BAA8B,sCAAsC,EAAE;;AAEtE;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,oCAAoC;EACpC,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,wBAAwB,aAAa,EAAE;;AAEvC;;;;;;6EAM6E;;AAE7E;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,8BAA8B;EAC9B,uBAAuB;EACvB,kCAAkC;EAClC,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA,gCAAgC,uBAAuB,EAAE,wBAAwB,EAAE;;AAEnF;qEACqE;AACrE;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,0EAA0E;AAC1E;EACE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;6EAW6E;;AAE7E;EACE,oCAAoC;EACpC,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,SAAS;AACX;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,mCAAmC;EACnC,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;EAC3B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;0CAE0C;AAC1C;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;qEAEqE;AACrE;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB;+CAC6C;EAC7C,aAAa;EACb,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,4BAA4B;EAC5B,iCAAiC;EACjC,kBAAkB;EAClB;0DACwD;AAC1D;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,qEAAqE;EACrE,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;;;;kBAIkB;AAClB;EACE,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA,yEAAyE;AACzE;EACE,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;EAC5B,gCAAgC;EAChC,mDAAmD;EACnD,mCAAmC;EACnC,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;oEAKoE;AACpE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;uDACuD;AACvD;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;;sEAEsE;AACtE;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;6EAqB6E;;AAE7E;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;;EAEf;qDACmD;EACnD,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;;EAErB,YAAY;EACZ,2EAA2E;EAC3E,wCAAwC;EACxC,kCAAkC;EAClC,2DAA2D;EAC3D,qCAAqC;EACrC,6CAA6C;;EAE7C,0BAA0B;EAC1B,2BAA2B;EAC3B;mDACiD;AACnD;;AAEA;;4CAE4C;AAC5C;;EAEE,gBAAgB;AAClB;;AAEA;EACE;IACE,4CAA4C;IAC5C,6CAA6C;EAC/C;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;4BAE4B;AAC5B;EACE,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;mDAImD;AACnD;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb;;;+DAG6D;EAC7D,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,8CAA8C;EAC9C,oCAAoC;EACpC,iCAAiC;EACjC,sDAAsD;AACxD;;AAEA;EACE,gCAAgC,eAAe,EAAE;AACnD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;;;;;;;;;;;;;;;;6EAgB6E;;AAE7E;EACE;;wEAEsE;EACtE,iCAAiC;AACnC;;AAEA;uDACuD;AACvD;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;0EAE0E;AAC1E;;;EAGE,qCAAqC;AACvC;;AAEA;;;8CAG8C;AAC9C;EACE,eAAe;AACjB;;AAEA;;2DAE2D;;AAE3D;;;;;;;;;;;;;;;;;;6EAkB6E;;AAE7E;;EAEE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;6EAgB6E;;AAE7E;;EAEE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;kDACkD;AAClD;EACE,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;sBACsB;AACtB;EACE,mBAAmB;EACnB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;sEAGsE;AACtE;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;6EAY6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;8DAC8D;AAC9D;EACE,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;yDAEyD;AACzD;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;6EAY6E;;AAE7E;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;;;;;;;;;8DAW8D;AAC9D;;;;;;;;;;;;;;;;;;gFAkBgF;AAChF;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;;mEAEmE;AACnE;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;8EAY8E;AAC9E;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;;4CAE4C;;AAE5C;;;sEAGsE;AACtE;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;;;;;;6EAO6E;;AAE7E;;;;;;;;;wDASwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;EAC5B;iDAC+C;EAC/C,kCAAkC;EAClC,8CAA8C;EAC9C,qCAAqC;EACrC,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;;;;;;;;mCAQmC;;AAEnC;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;2EAC2E;AAC3E;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;;;;;6EAmB6E;;AAE7E;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,MAAM;AACR;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B;oBACkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;mEACmE;AACnE;EACE,cAAc;EACd,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB;gEAC8D;EAC9D;;;;;;GAMC;AACH;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;yDAMyD;AACzD;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;wDAEwD;AACxD;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;6EAa6E;;AAE7E;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;mDACmD;AACnD;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;wBACwB;AACxB;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;kEAEkE;AAClE;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;sBACsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;EAiBE;AACF;;;;;;;;;;;kCAWkC;AAClC;EACE,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;+BAC+B;AAC/B;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;;;wEAGwE;AACxE;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;2EAgB2E;AAC3E;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;yEAQyE;AACzE;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;;;qEAOqE;AACrE;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;6EAoB6E;;AAE7E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gFAAgF;EAChF,4BAA4B;EAC5B,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;EAC7B,gBAAgB;EAChB;;;;;iDAK+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;6BAI6B;AAC7B;EACE,oBAAoB;EACpB,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;6EAa6E;;AAE7E;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;oDAIoD;AACpD;EACE,mCAAmC;EACnC,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;iDAIiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,SAAS;AACX;;AAEA;;wDAEwD;AACxD;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;iDACiD;AACjD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA,wEAAwE;AACxE;EACE,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;;;0CAI0C;AAC1C;EACE,aAAa;AACf;;AAEA,0EAA0E;AAC1E;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;6EAa6E;;AAE7E;;;;;;;;;;;EAWE,eAAe;EACf,gBAAgB;AAClB;;AAEA;2EAC2E;AAC3E;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;oCACoC;AACpC;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;;qEAGqE;;AAErE;;;;qDAIqD;AACrD;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;;;;;;;;;;;+EAW+E;AAC/E;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,6EAA6E;;AAE7E;;;;;;;;kCAQkC;AAClC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;8EAE8E;AAC9E;EACE,uBAAuB;AACzB;;AAEA,6EAA6E;;AAE7E;;;;;;;;;;;4EAW4E;AAC5E;EACE;;;8EAG4E;EAC5E,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;uEAEuE;AACvE;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   Screen-level layout\n\n   The shared structure every screen follows on mobile:\n\n     Top app bar   (appbar.css)\n     Page header   — one title, optional one-line context, no breadcrumb\n     Content       — sections at the 16px gutter, cards, lists\n     Primary action— sticky when the screen has one that matters\n     Bottom nav    (untouched)\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* ── The shell ──────────────────────────────────────────────────────────── */\nhtml.m-app .app-shell {\n  background: var(--m-surface-page);\n  /* Belt and braces with the existing bottom-nav padding rule: this one is\n     safe-area aware, so on a gesture-nav phone the last row of content\n     clears the home indicator too. */\n  min-height: 100dvh;\n}\n\nhtml.m-app .app-shell-with-bottom-nav {\n  padding-bottom: var(--m-bottomnav-total);\n}\n\n/* Every page container drops the desktop's centred max-width and generous\n   vertical padding down to the mobile gutter. */\nhtml.m-app :is(\n  .settings-page, .settings-container,\n  .dash-page, .oh-page, .pdp-page, .wl-page, .ntf-page,\n  .ab-page, .pf-page, .cartpg-grid, .checkout-container,\n  .about-page, .contact-page, .faq-page, .careers-page,\n  .privacy-page, .cookie-page, .ret-page, .brands-page\n) {\n  max-width: none;\n  width: 100%;\n  margin: 0;\n  padding-left: var(--m-gutter);\n  padding-right: var(--m-gutter);\n  padding-top: var(--m-4);\n}\n\n/* Multi-column page grids become one column. */\nhtml.m-app :is(\n  .settings-grid, .cartpg-grid, .cookie-layout, .checkout-grid,\n  .dash-grid, .pdp-layout, .oh-layout, .about-grid\n) {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-4);\n}\n\nhtml.m-app :is(.settings-side-column, .cartpg-side, .cartpg-col, .cookie-side) {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-4);\n  width: 100%;\n}\n\n/* ── Page header ────────────────────────────────────────────────────────\n   One title at 22px, one line of context at 13px. The desktop versions run\n   to 34px with a breadcrumb trail underneath; on a phone the app bar\n   already says where you are, and the OS back gesture is the trail. */\nhtml.m-app :is(\n  .settings-page-heading, .oh-page-header, .ab-page-hdr,\n  .pf-page-hdr, .wl-page-hdr, .ntf-page-hdr, .m-page-header\n) {\n  margin: 0 0 var(--m-4);\n  padding: 0;\n  border: none;\n}\n\nhtml.m-app :is(\n  .settings-page-heading h1, .oh-page-header h1, .ab-page-title,\n  .pf-page-title, .wl-page-title, .ntf-page-title, .dash-greeting,\n  .cartpg-hd-title, .m-page-title\n) {\n  font-size: var(--m-fs-page-title);\n  font-weight: var(--m-fw-bold);\n  line-height: var(--m-lh-tight);\n  letter-spacing: var(--m-track-title);\n  margin: 0 0 var(--m-1);\n}\n\nhtml.m-app :is(\n  .settings-page-heading p, .ab-page-sub, .pf-page-sub,\n  .wl-page-sub, .ntf-page-sub, .m-page-sub\n) {\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* Breadcrumbs: the app bar's back button already carries this, and a trail\n   of four links at the top of a phone screen is four mis-tap targets. */\nhtml.m-app :is(.oh-breadcrumb, .pdp-breadcrumb, .breadcrumb, .cookie-breadcrumb) {\n  display: none;\n}\n\n/* Section heading inside a screen: title left, one optional link right. */\nhtml.m-app :is(.sf-section-hd, .dash-section-hdr, .m-section-hd) {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: var(--m-3);\n  padding: 0 var(--m-gutter);\n  margin: var(--m-5) 0 var(--m-3);\n}\n\nhtml.m-app :is(.sf-section-hd h2, .dash-section-hdr h2, .m-section-hd h2) {\n  font-size: var(--m-fs-section);\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: var(--m-track-title);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--m-2);\n}\n\nhtml.m-app :is(.dash-section-link, .m-section-link, .sf-section-hd a) {\n  flex: 0 0 auto;\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-medium);\n  color: var(--color-secondary-text);\n  white-space: nowrap;\n}\n\n/* Sections already inside a gutter-padded page must not double-indent. */\nhtml.m-app :is(.settings-page, .dash-page, .oh-page) :is(.sf-section-hd, .dash-section-hdr, .m-section-hd),\nhtml.m-app :is(.settings-page, .dash-page, .oh-page) .product-grid {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Home / storefront\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* Delivery address row: a single 44px line, not a 68px banner. */\nhtml.m-app .mtb-delivery-row {\n  display: flex;\n  align-items: center;\n  gap: var(--m-2);\n  width: 100%;\n  min-height: var(--m-touch);\n  padding: var(--m-2) var(--m-gutter);\n  border: none;\n  border-bottom: 1px solid var(--m-hairline);\n  background: var(--m-surface-card);\n}\n\nhtml.m-app .mtb-delivery-text {\n  display: flex;\n  align-items: baseline;\n  gap: var(--m-1);\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\nhtml.m-app .mtb-delivery-label {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-regular);\n  text-transform: none;\n  letter-spacing: 0;\n  color: var(--color-text-muted);\n  white-space: nowrap;\n}\n\nhtml.m-app .mtb-delivery-value {\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-semibold);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n/* Category rail: compact tiles, ~5 visible with the sixth peeking. */\nhtml.m-app .mtb-cat-strip {\n  display: flex;\n  gap: var(--m-1);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x proximity;\n  scrollbar-width: none;\n  padding: var(--m-3) var(--m-gutter);\n  background: var(--m-surface-card);\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .mtb-cat-strip::-webkit-scrollbar { display: none; }\n\nhtml.m-app .mtb-cat-tile {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--m-1);\n  width: 64px;\n  min-height: 62px;\n  padding: var(--m-1);\n  border: none;\n  border-radius: var(--m-r-sm);\n  background: transparent;\n  scroll-snap-align: start;\n}\n\nhtml.m-app .mtb-cat-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--m-r-pill);\n  background: var(--m-surface-sunken);\n  color: var(--color-text-primary);\n}\n\nhtml.m-app .mtb-cat-icon svg { width: var(--m-icon); height: var(--m-icon); }\n\nhtml.m-app .mtb-cat-tile.active .mtb-cat-icon {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n\nhtml.m-app .mtb-cat-label {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-medium);\n  line-height: 1.15;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\nhtml.m-app .mtb-cat-tile.active .mtb-cat-label {\n  color: var(--color-secondary-text);\n  font-weight: var(--m-fw-semibold);\n}\n\n/* Recently viewed rail */\nhtml.m-app .mtb-recent { padding: var(--m-4) 0 0; }\n\nhtml.m-app .mtb-recent-title {\n  display: flex;\n  align-items: center;\n  gap: var(--m-2);\n  font-size: var(--m-fs-section);\n  font-weight: var(--m-fw-semibold);\n  margin: 0 var(--m-gutter) var(--m-3);\n}\n\nhtml.m-app .mtb-recent-strip {\n  display: flex;\n  gap: var(--m-3);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x proximity;\n  scrollbar-width: none;\n  padding: 0 var(--m-gutter);\n}\n\nhtml.m-app .mtb-recent-strip::-webkit-scrollbar { display: none; }\n\nhtml.m-app .mtb-recent-card {\n  flex: 0 0 auto;\n  width: 110px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  text-align: left;\n  scroll-snap-align: start;\n}\n\nhtml.m-app .mtb-recent-img-wrap {\n  display: block;\n  width: 110px;\n  height: 110px;\n  border-radius: var(--m-r-sm);\n  overflow: hidden;\n  background: var(--m-surface-sunken);\n  margin-bottom: var(--m-2);\n}\n\nhtml.m-app .mtb-recent-img { width: 100%; height: 100%; object-fit: cover; }\n\nhtml.m-app .mtb-recent-name {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .mtb-recent-price {\n  display: block;\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-bold);\n  margin-top: 2px;\n}\n\n/* Hero carousel.\n\n   App.css already has a genuinely mobile treatment for this at <=600px: one\n   slide at 88% width (so the next peeks), a 185px box, an 18px title and\n   .slide-body hidden. That is the right shape, and an earlier pass here\n   broke it by re-showing .slide-body and pushing the title back up to 22px —\n   which overflowed the 185px slide and clipped the CTA off the bottom.\n\n   So this deliberately does NOT restyle the slide's copy. It only removes\n   the overlay arrows (two 28px targets sitting on the slide's own tap area,\n   below the 44px floor, and redundant with the swipe the track already\n   supports), aligns the rail to the 16px gutter, and gives the CTA a real\n   touch target. */\nhtml.m-app .hero-carousel {\n  margin: var(--m-3) 0;\n}\n\nhtml.m-app .carousel-track {\n  padding-inline: var(--m-gutter);\n  gap: var(--m-3);\n}\n\nhtml.m-app .carousel-slide {\n  border-radius: var(--m-r);\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app .slide-cta {\n  min-height: var(--m-touch);\n  padding: 0 var(--m-4);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-button);\n  font-weight: var(--m-fw-semibold);\n}\n\nhtml.m-app .slide-badge,\nhtml.m-app .slide-discount-badge {\n  font-size: var(--m-fs-caption);\n  padding: 2px var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\nhtml.m-app .carousel-arrow {\n  display: none;\n}\n\nhtml.m-app .carousel-dots,\nhtml.m-app .cat-carousel-dots {\n  display: flex;\n  justify-content: center;\n  gap: var(--m-1);\n  padding: var(--m-2) 0 0;\n}\n\nhtml.m-app .carousel-dot,\nhtml.m-app .cat-carousel-dot {\n  width: 6px;\n  height: 6px;\n  min-height: 6px;\n  border-radius: var(--m-r-pill);\n  background: var(--m-hairline-strong);\n  transition: width var(--m-dur) var(--m-ease);\n}\n\nhtml.m-app .carousel-dot.active,\nhtml.m-app .cat-carousel-dot.active {\n  width: 18px;\n  background: var(--color-secondary);\n}\n\n/* Trust list (cart / checkout reassurance).\n\n   This is a vertical list separated by hairlines, not a horizontal strip —\n   an earlier pass turned it into a scroller and left the icons and copy\n   misaligned. It stays a list; only the measure changes. */\nhtml.m-app .cs-trust-item {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  padding: var(--m-3) 0;\n  border-top: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .cs-trust-icon {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  flex: 0 0 auto;\n}\n\nhtml.m-app .cs-trust-icon svg { width: var(--m-icon); height: var(--m-icon); }\n\nhtml.m-app .cs-trust-title {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .cs-trust-sub {\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-secondary);\n}\n\n/* The storefront's sort control sits beside a 24px \"All Products\" heading\n   on desktop; on mobile the heading shrinks and sort becomes a chip. */\nhtml.m-app .shop-toolbar,\nhtml.m-app .sf-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--m-2);\n  padding: 0 var(--m-gutter);\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .sf-toolbar select,\nhtml.m-app .shop-toolbar select {\n  width: auto;\n  min-width: 0;\n  height: 36px;\n  min-height: 36px;\n  padding: 0 var(--m-6) 0 var(--m-3);\n  border-radius: var(--m-r-pill);\n  font-size: var(--m-fs-secondary);\n  background-color: var(--m-surface-card);\n}\n\n/* Desktop filter sidebar → a sheet, opened from the toolbar. */\nhtml.m-app .sf-sidebar,\nhtml.m-app .shop-sidebar {\n  display: none;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Product detail\n\n   The heaviest screen in the app. Order on mobile: image, identity, price,\n   then everything else — with the buy action pinned so it's reachable from\n   any scroll position instead of living 400px down.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .pdp-page {\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  /* Clears the pinned buy bar, which sits above the bottom nav. */\n  padding-bottom: calc(var(--m-control-lg) + var(--m-5));\n}\n\n/* Gallery: edge to edge, no card frame. A bordered, rounded, shadowed box\n   around a product photo is a desktop convention — on a phone the image is\n   the screen, and the frame just costs 16px of width on both sides plus a\n   visual seam between the photo and the page.\n\n   The frame lives on .pdp-main-img-wrap, not .pdp-gallery (which is only\n   the flex row pairing the thumbnails with the stage). */\nhtml.m-app .pdp-gallery {\n  width: 100%;\n  gap: 0;\n  margin: 0 0 var(--m-3);\n  padding: 0;\n}\n\nhtml.m-app .pdp-main-img-wrap {\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  background: var(--m-surface-card);\n}\n\n/* 320px of forced min-height plus a 420px fixed image height overflowed\n   the stage on a 390px screen. The stage becomes a true square sized by its\n   own aspect ratio (flex:0 0 auto so it isn't squashed by the quantity row\n   below it), and the image is told to fit inside that square rather than\n   carry a fixed pixel height of its own.\n\n   Zoom-on-hover is removed: there is no hover on a phone, and the transform\n   left the photo mid-scale after a tap. */\nhtml.m-app .pdp-main-img-stage {\n  flex: 0 0 auto;\n  min-height: 0;\n  /* 4:3 rather than square. Product photos here are predominantly\n     landscape, and `object-fit: contain` (correct — a product must never be\n     cropped) letterboxes whatever the frame doesn't match. A square frame\n     left ~90px of empty white between the photo and the quantity row on\n     every listing; 4:3 spends that space on the photo instead, and a\n     portrait image still fits, just with padding at the sides. */\n  aspect-ratio: 4 / 3;\n  cursor: default;\n}\n\nhtml.m-app .pdp-main-img-stage:hover .pdp-main-img-inner {\n  transform: none;\n}\n\n/* The base rule pins this to height:420px, which is taller than the stage\n   it lives in. border-box is the load-bearing part: without it the 12px\n   padding is added *outside* the 100% height and the photo bleeds past both\n   edges of its own box. */\nhtml.m-app .pdp-main-img,\nhtml.m-app .pdp-main-img-fallback {\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: var(--m-3);\n  object-fit: contain;\n}\n\n/* Quantity sits inside the image card on desktop. On mobile it belongs\n   with the buy action in the sticky bar, so it comes out of the gallery. */\n/* Quantity sits inside the image card on desktop. It stays there rather\n   than moving into the sticky bar — the bar already holds two actions and a\n   third control would crowd all three under the 44px floor — but it gets a\n   hairline of its own and label styling so it reads as a control, not a\n   caption floating under the photo. */\nhtml.m-app .pdp-img-qty-row {\n  justify-content: space-between;\n  gap: var(--m-3);\n  padding: var(--m-2) var(--m-gutter);\n  min-height: var(--m-touch);\n  border-top: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .pdp-img-config-label {\n  font-size: var(--m-fs-label);\n  font-weight: var(--m-fw-medium);\n  color: var(--color-text-secondary);\n  min-width: 0;\n}\n\n/* Prev/next overlay buttons duplicate the swipe the track already\n   supports, and sit on top of the image's own tap target. */\nhtml.m-app .pdp-img-prev,\nhtml.m-app .pdp-img-next {\n  display: none;\n}\n\nhtml.m-app .pdp-img-counter,\nhtml.m-app .pdp-img-badge {\n  font-size: var(--m-fs-caption);\n  padding: 2px var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\n/* The thumbnail rail is a vertical column beside the image on desktop and\n   is flipped to a row underneath it at tablet width. Here it's a horizontal\n   scroller on the gutter, and it collapses entirely for a single-image\n   product rather than leaving an orphaned 52px square. */\nhtml.m-app .pdp-thumbs,\nhtml.m-app .pdp-thumb-strip {\n  display: flex;\n  flex-direction: row;\n  gap: var(--m-2);\n  overflow-x: auto;\n  scrollbar-width: none;\n  padding: var(--m-3) var(--m-gutter) 0;\n}\n\nhtml.m-app .pdp-thumbs:not(:has(.pdp-thumb + .pdp-thumb)) {\n  display: none;\n}\n\nhtml.m-app .pdp-thumbs::-webkit-scrollbar,\nhtml.m-app .pdp-thumb-strip::-webkit-scrollbar { display: none; }\n\nhtml.m-app .pdp-thumb {\n  flex: 0 0 auto;\n  width: 52px;\n  height: 52px;\n  min-height: 52px;\n  border-radius: var(--m-r-xs);\n}\n\nhtml.m-app .pdp-info,\nhtml.m-app .pdp-summary {\n  padding: 0 var(--m-gutter);\n}\n\nhtml.m-app .pdp-cat-label {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--color-secondary-text);\n  margin-bottom: var(--m-1);\n}\n\nhtml.m-app .pdp-title,\nhtml.m-app .pdp-page h1 {\n  font-size: var(--m-fs-page-title);\n  font-weight: var(--m-fw-bold);\n  line-height: var(--m-lh-tight);\n  letter-spacing: var(--m-track-title);\n  margin: 0 0 var(--m-2);\n  padding: 0 var(--m-gutter);\n}\n\nhtml.m-app .pdp-price,\nhtml.m-app .pdp-price-now {\n  font-size: 1.5rem;    /* 24px — the only number on the screen this size */\n  font-weight: var(--m-fw-bold);\n  letter-spacing: var(--m-track-title);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .pdp-price-was {\n  font-size: var(--m-fs-body);\n  color: var(--color-text-muted);\n  text-decoration: line-through;\n}\n\n/* Share is a secondary action; on desktop it's a row of three labelled\n   buttons above the fold. It moves into the app bar's overflow on mobile —\n   here it's simply out of the primary reading path. */\n/* Share is a secondary action. Left as a wrapping row it took two lines\n   and 106px directly under the product title, above the price. It becomes\n   a single scrolling line of small chips. */\nhtml.m-app .pdp-share-row {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: var(--m-2);\n  padding: var(--m-2) var(--m-gutter) var(--m-3);\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\nhtml.m-app .pdp-share-row::-webkit-scrollbar { display: none; }\n\nhtml.m-app .pdp-share-row > span:first-child {\n  font-size: var(--m-fs-label);\n  color: var(--color-text-muted);\n  flex: 0 0 auto;\n}\n\nhtml.m-app .pdp-share-row button,\nhtml.m-app .pdp-share-row a {\n  flex: 0 0 auto;\n  min-height: 36px;\n  padding: 0 var(--m-3);\n  border-radius: var(--m-r-pill);\n  font-size: var(--m-fs-secondary);\n}\n\nhtml.m-app .pdp-badges-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--m-2);\n  padding: 0 var(--m-gutter);\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .pdp-bestseller-badge {\n  font-size: var(--m-fs-caption);\n  padding: var(--m-1) var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\n/* Long-form blocks — description, specs, delivery options, benefits,\n   frequently-bought-together, reviews, Q&A — become collapsed sections so\n   the page is scannable rather than a 5000px scroll. */\nhtml.m-app :is(\n  .pdp-desc-section, .pdp-specs-section, .pdp-delivery-card,\n  .pdp-benefits-card, .pdp-buyer-protection, .pdp-fbt-card,\n  .pdp-reviews-section, .pdp-qa-section\n) {\n  margin: 0 var(--m-gutter) var(--m-3);\n  padding: var(--m-4);\n  border-radius: var(--m-r);\n  border: 1px solid var(--m-hairline);\n  background: var(--m-surface-card);\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app .pdp-desc-short,\nhtml.m-app .pdp-desc-list {\n  font-size: var(--m-fs-body);\n  line-height: var(--m-lh-body);\n}\n\nhtml.m-app .pdp-feature-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--m-2);\n}\n\nhtml.m-app .pdp-feature-chip {\n  font-size: var(--m-fs-caption);\n  padding: var(--m-1) var(--m-2);\n  border-radius: var(--m-r-pill);\n}\n\n/* Colour swatches: real targets, and the product's own colours are exempt\n   from the four-colour palette by design. */\nhtml.m-app .pdp-colors-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--m-2);\n  padding: 0 var(--m-gutter) var(--m-3);\n}\n\nhtml.m-app .pdp-color-swatch {\n  width: 36px;\n  height: 36px;\n  min-height: 36px;\n  border-radius: var(--m-r-pill);\n}\n\nhtml.m-app .pdp-colors-label,\nhtml.m-app .pdp-del-section-title {\n  font-size: var(--m-fs-label);\n  font-weight: var(--m-fw-medium);\n  color: var(--color-text-secondary);\n  padding: 0 var(--m-gutter);\n  margin-bottom: var(--m-2);\n}\n\n/* Delivery options as choice rows. */\nhtml.m-app .pdp-del-opt {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  min-height: 56px;\n  padding: var(--m-2) 0;\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .pdp-del-name { font-size: var(--m-fs-body); font-weight: var(--m-fw-medium); }\nhtml.m-app .pdp-del-date { font-size: var(--m-fs-caption); color: var(--color-text-secondary); }\nhtml.m-app .pdp-del-price { font-size: var(--m-fs-secondary); font-weight: var(--m-fw-semibold); margin-left: auto; }\n\n/* ── Sticky buy bar ─────────────────────────────────────────────────────\n   Add to Cart / Buy Now live in .pdp-sidebar-actions, roughly 900px down a\n   5600px page. Rather than render a second copy of them (which would mean\n   duplicating the variant/size validation each button runs, and risking the\n   two drifting apart), the existing block is pinned in place. Same nodes,\n   same handlers, same state — just always reachable.\n\n   Stacked vertically on desktop, they sit side by side here, with a clear\n   hierarchy rather than two identical orange slabs: Add to Cart takes the\n   solid orange fill the design system reserves for the primary commercial\n   action, and Buy Now becomes an outline of the same hue. */\nhtml.m-app .pdp-sidebar-actions {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: var(--m-bottomnav-total);\n  z-index: 190;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--m-2);\n  padding: var(--m-2) var(--m-gutter);\n  padding-left: max(var(--m-gutter), var(--m-safe-left));\n  padding-right: max(var(--m-gutter), var(--m-safe-right));\n  background: var(--m-surface-bar);\n  border-top: 1px solid var(--m-hairline);\n  box-shadow: var(--m-shadow-sticky);\n}\n\n@supports (backdrop-filter: blur(12px)) {\n  html.m-app .pdp-sidebar-actions {\n    background: color-mix(in srgb, var(--m-surface-bar) 90%, transparent);\n    backdrop-filter: saturate(180%) blur(16px);\n    -webkit-backdrop-filter: saturate(180%) blur(16px);\n  }\n}\n\nhtml.m-app .pdp-sidebar-actions .pdp-add-cart-btn,\nhtml.m-app .pdp-sidebar-actions .pdp-buy-now-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--m-2);\n  flex: 1 1 0;\n  width: auto;\n  min-height: var(--m-control-lg);\n  padding: 0 var(--m-3);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-button);\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: 0;\n  white-space: nowrap;\n}\n\nhtml.m-app .pdp-sidebar-actions svg { flex: 0 0 auto; }\n\n/* Buy Now steps back to an outline so the two actions aren't equally\n   prominent. The gradient and its orange glow are dropped: a heavy drop\n   shadow under a bar that's already elevated reads as two stacked layers. */\nhtml.m-app .pdp-sidebar-actions .pdp-buy-now-btn {\n  background: transparent;\n  border: 1.5px solid var(--color-primary);\n  color: var(--color-text-primary);\n  box-shadow: none;\n}\n\nhtml.m-app .pdp-sidebar-actions .pdp-add-cart-btn {\n  background: var(--color-primary);\n  /* Navy on orange: 7.4:1. White would be 2.8:1. */\n  color: var(--color-text-on-primary);\n  box-shadow: none;\n}\n\n/* The back-in-stock form replaces the buy actions when a product is\n   unavailable; it's a form, not a one-tap action, so it stays in flow. */\nhtml.m-app .pdp-notify-wrap {\n  margin: 0 var(--m-gutter) var(--m-3);\n  padding: var(--m-4);\n  border-radius: var(--m-r);\n}\n\nhtml.m-app .pdp-benefit-title { font-size: var(--m-fs-body); font-weight: var(--m-fw-medium); }\nhtml.m-app .pdp-benefit-sub { font-size: var(--m-fs-caption); color: var(--color-text-secondary); }\nhtml.m-app .pdp-benefit-item { gap: var(--m-3); padding: var(--m-2) 0; }\nhtml.m-app .pdp-benefit-icon svg { width: var(--m-icon); height: var(--m-icon); }\n\n/* ════════════════════════════════════════════════════════════════════════\n   Cart and checkout\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .cs-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--m-3);\n  padding: var(--m-3) 0;\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .cs-item-img,\nhtml.m-app .cs-item img {\n  width: 64px;\n  height: 64px;\n  min-width: 64px;\n  border-radius: var(--m-r-xs);\n  object-fit: cover;\n}\n\nhtml.m-app .cs-item-name {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-medium);\n  line-height: var(--m-lh-snug);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\nhtml.m-app .cs-item-price {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-bold);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .cs-item-action {\n  min-height: var(--m-touch);\n  font-size: var(--m-fs-secondary);\n  padding: 0 var(--m-2);\n}\n\n/* Free-shipping progress */\nhtml.m-app .cs-fs-bar { padding: var(--m-3); border-radius: var(--m-r-sm); }\nhtml.m-app .cs-fs-title { font-size: var(--m-fs-secondary); font-weight: var(--m-fw-semibold); }\nhtml.m-app .cs-fs-sub { font-size: var(--m-fs-caption); }\nhtml.m-app .cs-fs-track { height: 6px; border-radius: var(--m-r-pill); }\n\n/* Empty cart: one illustration at a sane size, one leading action. The\n   second button drops to a text link so the two don't compete. */\nhtml.m-app .cs-empty,\nhtml.m-app .cartpg-empty-layout {\n  padding: var(--m-8) var(--m-gutter);\n  gap: var(--m-2);\n}\n\nhtml.m-app .cs-empty-illustration {\n  transform: scale(0.62);\n  transform-origin: center;\n  margin: calc(var(--m-6) * -1) 0;\n}\n\nhtml.m-app .cs-empty-title {\n  font-size: var(--m-fs-section);\n  font-weight: var(--m-fw-semibold);\n}\n\nhtml.m-app .cs-empty-sub {\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n  max-width: 32ch;\n}\n\nhtml.m-app .cs-empty-continue-btn {\n  width: 100%;\n  min-height: var(--m-control-lg);\n  border-radius: var(--m-r-sm);\n  font-size: 1rem;\n  font-weight: var(--m-fw-semibold);\n  background: var(--color-secondary);\n  /* Navy on blue: 5.6:1. The white this replaced was 3.1:1. */\n  color: var(--color-text-on-secondary);\n  border: none;\n}\n\nhtml.m-app .cs-empty-categories-btn {\n  width: 100%;\n  min-height: var(--m-touch);\n  background: transparent;\n  border: none;\n  color: var(--color-secondary-text);\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-medium);\n}\n\n/* Order summary: a tight table of figures. The discount row is the one\n   place in the app a rate may be shown, and it stays exactly as the server\n   returned it. */\nhtml.m-app :is(.cod-order-recap, .cs-totals, .co-recap) {\n  padding: var(--m-4);\n  border-radius: var(--m-r);\n  border: 1px solid var(--m-hairline);\n  background: var(--m-surface-card);\n}\n\nhtml.m-app :is(.cs-total-row, .price-row, .discount-row) {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--m-3);\n  min-height: 30px;\n  font-size: var(--m-fs-body);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app :is(.cs-total-row, .price-row) span:last-child {\n  font-weight: var(--m-fw-medium);\n}\n\nhtml.m-app .total,\nhtml.m-app .cs-total-row.total {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-bold);\n  padding-top: var(--m-3);\n  margin-top: var(--m-2);\n  border-top: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .checkout-step-pad {\n  padding: 0 0 var(--m-4);\n}\n\nhtml.m-app .co-panel {\n  margin-bottom: var(--m-3);\n}\n\n/* .co-radio is the 18px radio DOT, not a choice row -- it is rendered as a\n   bare <span className=\"co-radio co-radio-on\" />. An earlier pass here\n   mistook it for a row and gave it min-height:56px plus padding and a\n   border; inside the payment card's flex row that stretched it into a tall\n   blue ellipse about 40x130. It keeps its own size. */\nhtml.m-app .co-radio {\n  flex: 0 0 auto;\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n  min-height: 18px;\n  padding: 0;\n  margin-top: 0;\n  align-self: center;\n}\n\nhtml.m-app .payment-method-card {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  min-height: 60px;\n  padding: var(--m-3);\n  border-radius: var(--m-r-sm);\n  margin-bottom: var(--m-2);\n}\n\n/* .coupon-section already stacks a label above a .coupon-input-row; making\n   the section itself a flex row put the \"Have a coupon?\" label BESIDE the\n   input, squeezing the field to about 90px and clipping its placeholder.\n   The section is the column; the inner row is the row. */\nhtml.m-app .coupon-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-2);\n  /* The base draws this as a DASHED border on a tinted fill. At this size a\n     dash pattern reads as a broken or placeholder edge rather than a\n     deliberate one -- especially against the dashed connector already used\n     in the order tracker, where dashes mean \"not yet\". A solid hairline on\n     the card surface says \"this is a field group\", which is what it is.\n\n     Padding restated because the base's 18px/20px was not surviving here,\n     so the label and the input row sat flush against the border. */\n  padding: var(--m-3);\n  border: 1px solid var(--m-hairline-strong);\n  border-radius: var(--m-r-sm);\n  background: var(--m-surface-card);\n  box-shadow: none;\n}\n\n/* The label inside the box: sentence case at label size. The base\n   uppercases it and adds letter-spacing, which at 12px in a small box\n   fights the placeholder directly beneath it for attention. */\nhtml.m-app .coupon-section h3 {\n  margin: 0;\n  font-size: var(--m-fs-label);\n  font-weight: var(--m-fw-medium);\n  color: var(--color-text-secondary);\n  text-transform: none;\n  letter-spacing: 0;\n}\n\nhtml.m-app .coupon-input-row {\n  display: flex;\n  align-items: center;\n  gap: var(--m-2);\n  width: 100%;\n}\n\n/* No icon in the field. A ticket glyph beside a box labelled \"Have a\n   coupon?\" restates the label and costs the input ~28px of the little width\n   it has -- the field was 183px on a 360px screen. Input and action, nothing\n   else. (The tick/cross on the feedback line below stays: those carry the\n   result, and in a four-colour system a status may not rest on hue alone.) */\nhtml.m-app .coupon-ticket-icon {\n  display: none;\n}\n\nhtml.m-app .coupon-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: var(--m-control);\n  padding: 0 var(--m-3);\n  border: 1px solid var(--m-hairline-strong);\n  border-radius: var(--m-r-sm);\n  background: var(--m-surface-card);\n  font-size: 1rem;\n  text-transform: uppercase;\n}\n\nhtml.m-app .coupon-input::placeholder {\n  font-size: var(--m-fs-body);\n  text-transform: none;\n  color: var(--color-text-muted);\n}\n\nhtml.m-app .coupon-apply-btn {\n  flex: 0 0 auto;\n  min-height: var(--m-control);\n  padding: 0 var(--m-4);\n  white-space: nowrap;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Account area\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .dash-greeting {\n  padding: 0 0 var(--m-4);\n}\n\n/* Recent orders as list rows rather than a table. */\nhtml.m-app .dash-order-row {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  min-height: 60px;\n  padding: var(--m-3) 0;\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .dash-order-id { font-size: var(--m-fs-body); font-weight: var(--m-fw-medium); }\nhtml.m-app .dash-order-date { font-size: var(--m-fs-caption); color: var(--color-text-secondary); }\nhtml.m-app .dash-order-total {\n  margin-left: auto;\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .dash-card-strip {\n  display: flex;\n  gap: var(--m-3);\n  overflow-x: auto;\n  scrollbar-width: none;\n  padding-bottom: var(--m-2);\n}\n\nhtml.m-app .dash-card-strip::-webkit-scrollbar { display: none; }\n\nhtml.m-app .dash-mini-card {\n  flex: 0 0 auto;\n  width: 120px;\n}\n\nhtml.m-app .dash-empty {\n  padding: var(--m-6) 0;\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\n/* Profile identity card */\nhtml.m-app .pf-avatar,\nhtml.m-app .profile-avatar {\n  width: 56px;\n  height: 56px;\n  min-width: 56px;\n}\n\nhtml.m-app .pf-name,\nhtml.m-app .profile-name {\n  font-size: var(--m-fs-section);\n  font-weight: var(--m-fw-semibold);\n}\n\nhtml.m-app .pf-meta-row {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  min-height: var(--m-touch);\n  padding: var(--m-2) 0;\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .pf-meta-label {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n}\n\nhtml.m-app .pf-meta-value {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-medium);\n}\n\n/* Notifications: list rows with an unread marker that isn't only colour. */\nhtml.m-app .ntf-item {\n  display: flex;\n  gap: var(--m-3);\n  align-items: flex-start;\n  padding: var(--m-3) var(--m-gutter);\n  border-bottom: 1px solid var(--m-hairline);\n  background: var(--m-surface-card);\n}\n\nhtml.m-app .ntf-item.unread {\n  background: var(--color-secondary-soft);\n}\n\nhtml.m-app .ntf-title {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .ntf-body {\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .ntf-time {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n  white-space: nowrap;\n}\n\n/* Addresses */\nhtml.m-app .ab-card {\n  padding: var(--m-4);\n}\n\nhtml.m-app .ab-card-name { font-size: var(--m-fs-body); font-weight: var(--m-fw-semibold); }\nhtml.m-app .ab-card-lines { font-size: var(--m-fs-secondary); color: var(--color-text-secondary); line-height: var(--m-lh-snug); }\n\nhtml.m-app .ab-card-actions {\n  display: flex;\n  gap: var(--m-2);\n  margin-top: var(--m-3);\n  padding-top: var(--m-3);\n  border-top: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .ab-card-actions button {\n  flex: 1 1 0;\n  min-height: var(--m-touch);\n  font-size: var(--m-fs-secondary);\n}\n\n/* Settings privacy block: one leading action, one destructive text action —\n   not two full-width filled buttons side by side. */\nhtml.m-app .settings-privacy-actions {\n  flex-direction: column;\n  gap: var(--m-2);\n  margin-top: var(--m-4);\n}\n\nhtml.m-app .settings-download-btn {\n  background: var(--color-secondary);\n  /* Navy on blue: 5.6:1, replacing white at 3.1:1. */\n  color: var(--color-text-on-secondary);\n  border-color: transparent;\n}\n\nhtml.m-app .settings-delete-btn {\n  width: 100%;\n  min-height: var(--m-touch);\n  background: transparent;\n  border: 1px solid var(--m-hairline-strong);\n}\n\nhtml.m-app .settings-privacy-note {\n  margin-top: var(--m-3);\n  padding: var(--m-3);\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  border-radius: var(--m-r-sm);\n}\n\n/* The <br> in the privacy note forces an awkward break at this width. */\nhtml.m-app .settings-privacy-note br { display: none; }\n\nhtml.m-app .settings-privacy-footer {\n  flex-wrap: wrap;\n  gap: var(--m-2);\n  min-height: 0;\n  margin-top: var(--m-5);\n  padding-top: var(--m-4);\n  font-size: var(--m-fs-caption);\n}\n\nhtml.m-app .settings-privacy-footer i { display: none; }\n\nhtml.m-app .settings-theme-note {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n  margin-top: var(--m-2);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Support chat launcher\n\n   The launcher keeps its original design: a vertical tab pinned to the right\n   edge at mid-height, with the label set in `writing-mode: vertical-rl`.\n\n   An earlier pass here replaced it with a circular FAB above the bottom nav,\n   on the assumption the tab was being clipped. It wasn't — it sits at\n   `top: 50%`, nowhere near the nav, and the tab is the established shape for\n   this app on every surface. Nothing is overridden now; only the panel it\n   opens is adapted below, which is a genuine difference between a phone and\n   a desktop window.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* The chat panel itself is a sheet, not a floating desktop window. */\n/* replaced below -- see the Support chat section */\n\nhtml.m-app .chat-widget-header {\n  min-height: var(--m-control);\n  padding: var(--m-3) var(--m-gutter);\n}\n\nhtml.m-app .chat-widget-header-title {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-semibold);\n}\n\nhtml.m-app .chat-widget-input-row {\n  gap: var(--m-2);\n  padding: var(--m-3) var(--m-gutter);\n  padding-bottom: calc(var(--m-3) + var(--m-safe-bottom));\n  border-top: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .chat-widget-msg {\n  font-size: var(--m-fs-body);\n  line-height: var(--m-lh-body);\n  padding: var(--m-2) var(--m-3);\n  border-radius: var(--m-r-sm);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Footer\n\n   A five-column sitemap with newsletter signup and payment marks is a\n   desktop artifact — inside the app it's dead weight below the bottom nav.\n   On mobile web it collapses to accordions; in the packaged app it goes.\n   Third-party brand marks keep their own colours, as on the web.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .ftr-grid,\nhtml.m-app .footer-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\nhtml.m-app .ftr-col,\nhtml.m-app .footer-col {\n  border-bottom: 1px solid color-mix(in srgb, var(--color-brand-white) 12%, transparent);\n  padding: var(--m-2) 0;\n}\n\nhtml.m-app :is(.ftr-col h3, .footer-col h3, .ftr-col-title) {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  /* Permanently-navy surface: these tokens never flip with the theme. */\n  color: var(--color-on-navy);\n  margin: 0;\n  min-height: var(--m-touch);\n  display: flex;\n  align-items: center;\n}\n\nhtml.m-app :is(.ftr-col a, .footer-col a) {\n  display: flex;\n  align-items: center;\n  min-height: var(--m-touch);\n  font-size: var(--m-fs-secondary);\n  color: var(--color-on-navy-secondary);\n}\n\nhtml.m-app .ftr-bottom,\nhtml.m-app .footer-bottom {\n  flex-direction: column;\n  gap: var(--m-3);\n  text-align: center;\n  font-size: var(--m-fs-caption);\n  color: var(--color-on-navy-muted);\n  padding: var(--m-4) var(--m-gutter);\n  padding-bottom: calc(var(--m-4) + var(--m-bottomnav-total));\n}\n\n/* Five link columns, legal links and payment marks are a website structure. In\n   an installed app -- packaged or PWA -- that content is either unreachable or\n   already in the bottom nav and account sheet, and it added a long scroll of\n   links under every page.\n   .m-installed carries the `.m-app` condition, so a PWA installed on a desktop\n   (wide window, no bottom nav) keeps its footer rather than losing its only\n   navigation. */\nhtml.m-installed .site-footer,\nhtml.m-installed .ftr-root,\nhtml.m-installed footer.ftr {\n  display: none;\n}\n\n\n/* ════════════════════════════════════════════════════════════════════════\n   Cart page header\n\n   Its own component (.cart-page-header), not SubPageHeader, and it shipped\n   both a back arrow and a close ✕ — two controls that do the same thing,\n   at opposite ends of the bar. Back is the one that matches the platform,\n   so the ✕ goes and the bar becomes a standard app bar.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .cart-page-header {\n  position: sticky;\n  top: 0;\n  z-index: 120;\n  padding-top: var(--m-safe-top);\n  background: var(--m-surface-bar);\n  border-bottom: 1px solid var(--m-hairline);\n  box-shadow: none;\n}\n\nhtml.m-app .cph-inner {\n  display: flex;\n  align-items: center;\n  gap: var(--m-1);\n  min-height: var(--m-appbar);\n  max-width: none;\n  padding: 0 var(--m-2) 0 var(--m-1);\n}\n\nhtml.m-app .cph-back {\n  width: var(--m-touch);\n  height: var(--m-touch);\n  min-width: var(--m-touch);\n  padding: 0;\n  border: none;\n  border-radius: var(--m-r-pill);\n  background: transparent;\n  color: var(--color-text-primary);\n  flex: 0 0 auto;\n}\n\nhtml.m-app .cph-back:active { background: var(--color-surface-hover); }\n\nhtml.m-app .cph-title {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 1.0625rem;\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: var(--m-track-title);\n  margin: 0;\n  padding-left: var(--m-1);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nhtml.m-app .cph-close { display: none; }\n\n/* ════════════════════════════════════════════════════════════════════════\n   Order history header\n\n   \"Export Orders\" is a power-user action that was sharing the title row\n   with equal visual weight. It steps down to a tertiary control so the\n   screen has one obvious subject — the orders themselves.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .oh-export-btn {\n  min-height: 36px;\n  padding: 0 var(--m-3);\n  border: 1px solid var(--m-hairline-strong);\n  border-radius: var(--m-r-pill);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-medium);\n  gap: var(--m-1);\n  white-space: nowrap;\n}\n\nhtml.m-app .oh-export-btn svg { width: var(--m-icon-sm); height: var(--m-icon-sm); }\n\n/* The date filter sits beside the search field; it needs enough room for\n   its longest option plus the caret, or \"All Time\" clips mid-word. */\nhtml.m-app .oh-date-select,\nhtml.m-app .oh-filter-right select {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: 108px;\n  height: var(--m-touch);\n  min-height: var(--m-touch);\n  padding: 0 var(--m-6) 0 var(--m-3);\n  border-radius: var(--m-r-pill);\n  font-size: var(--m-fs-secondary);\n}\n\nhtml.m-app .oh-filter-right {\n  flex: 0 0 auto;\n  gap: var(--m-2);\n}\n\n/* Nothing in this layer should render text below the 11px caption size. */\nhtml.m-app .sr-progress-label {\n  font-size: var(--m-fs-caption);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Frequently Bought Together\n\n   The desktop layout runs the bundle horizontally — three narrow cards\n   separated by \"+\" and \"=\" signs, ending in a total column. On a 360px\n   screen that collapses into a column of cramped tiles with the maths signs\n   stranded down the left edge.\n\n   Mobile turns each product into a full-width row — checkbox, thumbnail,\n   then a name / rating / price stack — with the \"+\" as a connector badge\n   between rows, a summary card for the totals, and one primary action.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .pdp-fbt {\n  margin: 0 var(--m-gutter) var(--m-4);\n  padding: 0;\n  border: none;\n  background: transparent;\n  box-shadow: none;\n}\n\nhtml.m-app .pdp-fbt-head {\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .pdp-fbt .pdp-section-h2 {\n  font-size: var(--m-fs-page-title);\n  font-weight: var(--m-fw-bold);\n  letter-spacing: var(--m-track-title);\n  margin: 0 0 2px;\n}\n\nhtml.m-app .pdp-fbt-sub {\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* The list: the horizontal flex row becomes a stack. */\nhtml.m-app .pdp-fbt-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  align-items: stretch;\n  flex-wrap: nowrap;\n  padding: 0;\n  border: none;\n  background: transparent;\n}\n\nhtml.m-app .pdp-fbt-item {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n}\n\n/* \"+\" between rows: a circular badge on the leading edge with a hairline\n   running through it, so three products read as one bundle rather than\n   three unrelated cards. */\nhtml.m-app .pdp-fbt-plus {\n  position: relative;\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  margin: var(--m-1) 0 var(--m-1) var(--m-4);\n  border: 1px solid var(--m-hairline);\n  border-radius: var(--m-r-pill);\n  background: var(--m-surface-card);\n  color: var(--color-text-secondary);\n  font-size: var(--m-fs-body);\n  line-height: 1;\n  z-index: 1;\n}\n\nhtml.m-app .pdp-fbt-plus::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: -8px;\n  bottom: -8px;\n  width: 1px;\n  margin-left: -0.5px;\n  background: var(--m-hairline);\n  z-index: -1;\n}\n\n/* Each product: one full-width row. */\nhtml.m-app .pdp-fbt-card {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  width: 100%;\n  padding: var(--m-3);\n  border: 1px solid var(--m-hairline);\n  border-radius: var(--m-r);\n  background: var(--m-surface-card);\n  box-shadow: var(--m-shadow-sm);\n  text-align: left;\n}\n\n/* An unticked item stays legible but visibly out of the bundle. The empty\n   checkbox is what actually states it; the dimming only reinforces, so the\n   meaning never rests on opacity alone. */\nhtml.m-app .pdp-fbt-card-off {\n  opacity: 0.55;\n  box-shadow: none;\n}\n\n/* Checkbox. The native input stays in the DOM and operable — moved\n   off-screen rather than display:none — so it keeps its role, its label\n   association and keyboard focus; the adjacent span draws the box. */\nhtml.m-app .pdp-fbt-check {\n  position: relative;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  /* Padding cancelled by negative margin grows the tap area to the 44px\n     floor without making the row any taller. */\n  padding: 11px;\n  margin: -11px 0 -11px -11px;\n  cursor: pointer;\n}\n\nhtml.m-app .pdp-fbt-check input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  min-height: 0;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  white-space: nowrap;\n}\n\nhtml.m-app .pdp-fbt-box {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 2px solid var(--m-hairline-strong);\n  border-radius: var(--m-r-xs);\n  background: var(--m-surface-card);\n  color: transparent;\n  transition: background-color var(--m-dur-fast) var(--m-ease),\n              border-color var(--m-dur-fast) var(--m-ease);\n}\n\nhtml.m-app .pdp-fbt-check input:checked + .pdp-fbt-box {\n  background: var(--color-secondary);\n  border-color: var(--color-secondary);\n  /* Navy on blue, matching every other filled control in the system. */\n  color: var(--color-text-on-secondary);\n}\n\nhtml.m-app .pdp-fbt-check input:focus-visible + .pdp-fbt-box {\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\nhtml.m-app .pdp-fbt-img {\n  flex: 0 0 auto;\n  width: 64px;\n  height: 64px;\n  border-radius: var(--m-r-sm);\n  object-fit: cover;\n  background: var(--m-surface-sunken);\n}\n\nhtml.m-app .pdp-fbt-info {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\nhtml.m-app .pdp-fbt-name {\n  margin: 0;\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .pdp-fbt-name .pcard-title-link {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n}\n\nhtml.m-app .pdp-fbt-rating-row {\n  margin: 0;\n  gap: var(--m-1);\n}\n\nhtml.m-app .pdp-fbt-price {\n  margin: 0;\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-bold);\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Summary card ───────────────────────────────────────────────────────── */\nhtml.m-app .pdp-fbt-summary {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  margin-top: var(--m-4);\n  padding: var(--m-4);\n  border: 1px solid var(--m-hairline);\n  border-radius: var(--m-r);\n  background: var(--m-surface-card);\n}\n\nhtml.m-app .pdp-fbt-summary-icon {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--m-r-pill);\n  background: var(--color-primary-soft);\n  color: var(--color-primary);\n}\n\nhtml.m-app .pdp-fbt-total-col {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: block;\n  padding: 0;\n  border: none;\n  background: transparent;\n}\n\nhtml.m-app .pdp-fbt-save-col {\n  flex: 0 0 auto;\n  text-align: right;\n  padding-left: var(--m-3);\n  border-left: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .pdp-fbt-total-label {\n  margin: 0;\n  font-size: var(--m-fs-label);\n  font-weight: var(--m-fw-medium);\n  color: var(--color-text-secondary);\n}\n\nhtml.m-app .pdp-fbt-total-val {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: var(--m-fw-bold);\n  line-height: 1.2;\n  letter-spacing: var(--m-track-title);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Savings in orange. The reference shows green, but green in this system is\n   reserved for product ratings and is explicitly excluded from discounts;\n   orange is the promotion colour. The !important beats the component's\n   inline style={{ color: BLUE }}. Swap this one declaration if the brand\n   rule changes. */\nhtml.m-app .pdp-fbt-save {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: var(--m-fw-bold);\n  line-height: 1.2;\n  font-variant-numeric: tabular-nums;\n  color: var(--color-primary) !important;\n}\n\n/* \"=\" is a horizontal-layout device; a stacked list has no use for it. */\nhtml.m-app .pdp-fbt-eq {\n  display: none;\n}\n\n/* ── Primary action ─────────────────────────────────────────────────────── */\nhtml.m-app .pdp-fbt-add-all {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--m-2);\n  width: 100%;\n  min-height: var(--m-control-lg);\n  margin-top: var(--m-3);\n  padding: 0 var(--m-4);\n  border: none;\n  border-radius: var(--m-r-sm);\n  background: var(--color-primary);\n  /* Navy on orange is 7.4:1; white would be 2.8:1. */\n  color: var(--color-text-on-primary);\n  font-size: 1rem;\n  font-weight: var(--m-fw-semibold);\n  white-space: nowrap;\n}\n\nhtml.m-app .pdp-fbt-add-all:disabled {\n  opacity: 0.45;\n}\n\n/* ── FBT: overriding the desktop row's own geometry ─────────────────────\n   The base card is `display:flex; flex-direction:column; align-items:center;\n   width:148px` — a narrow vertical tile. Setting `display:flex` alone left\n   the column direction in place, so the mobile row still stacked its\n   checkbox, image and text on top of each other. Every property that\n   defines the tile has to be answered, not just the display mode. */\nhtml.m-app .pdp-fbt-card {\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  gap: var(--m-3);\n}\n\n/* 92px with 6px of padding and object-fit:contain is sized for the tile. */\nhtml.m-app .pdp-fbt-img {\n  width: 64px;\n  height: 64px;\n  padding: 0;\n  object-fit: cover;\n}\n\n/* The tile centres its copy; a row reads left-aligned. */\nhtml.m-app .pdp-fbt-name {\n  text-align: left;\n  color: var(--color-text-primary);\n  display: block;\n  -webkit-line-clamp: none;\n}\n\nhtml.m-app .pdp-fbt-rating-row {\n  justify-content: flex-start;\n}\n\n/* `margin-left: auto` pushed the totals to the far end of the desktop flex\n   row; inside the summary card it just strands them. */\nhtml.m-app .pdp-fbt-total-col {\n  margin-left: 0;\n  align-items: flex-start;\n}\n\n/* The base button is a blue gradient with a blue glow, sized for a desktop\n   row. Orange is the commercial action colour, and a heavy drop shadow\n   under a full-width button reads as two stacked layers on a phone. */\nhtml.m-app .pdp-fbt-add-all {\n  background: var(--color-primary);\n  box-shadow: none;\n  padding: 0 var(--m-4);\n}\n\nhtml.m-app .pdp-fbt-add-all:hover {\n  background: var(--color-primary);\n  transform: none;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Support chat — collapsible edge tab\n\n   The launcher is persistent chrome on every screen, so the only honest way\n   to keep it from covering products is to make it genuinely small. It sits\n   flush to the right edge, vertically centred, 30px wide — a strip, not a\n   button — carrying an icon, the label and a chevron pointing at the edge\n   the panel comes from.\n\n   Notes on the mechanics:\n\n   · `position: fixed` keeps it put through scrolling, and centring on the\n     viewport means it only ever overlaps a ~120px band in the middle of the\n     right edge rather than sitting over the thumb zone.\n   · A fixed <button> does not block page scrolling — a touch that starts on\n     it and drags still scrolls the page — so nothing here interferes with\n     scrolling a product grid underneath. `touch-action: manipulation` only\n     removes the double-tap-zoom delay so the tap registers immediately.\n   · Hover is gated behind `(hover: hover)`. On a touch screen :hover sticks\n     after a tap until you tap elsewhere, which would leave the tab stuck in\n     its slid-out state.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .chat-side-tab {\n  position: fixed;\n  right: 0;\n  top: 50%;\n  left: auto;\n  bottom: auto;\n  z-index: 180;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--m-1);\n\n  /* 30px, down from 44. Narrow enough to read as an edge affordance rather\n     than a floating control parked on the content. */\n  width: 30px;\n  min-width: 0;\n  min-height: 0;\n  padding: var(--m-3) 0;\n\n  border: none;\n  /* Rounded on the leading side only, so it reads as attached to the edge. */\n  border-radius: var(--m-r) 0 0 var(--m-r);\n  background: var(--color-secondary);\n  /* Navy on blue: 5.6:1. White would be 3.1:1 and fail AA. */\n  color: var(--color-text-on-secondary);\n  box-shadow: -2px 0 10px rgba(1, 13, 33, 0.18);\n\n  touch-action: manipulation;\n  transform: translateY(-50%);\n  transition: transform var(--m-dur) var(--m-ease),\n              box-shadow var(--m-dur) var(--m-ease);\n}\n\n/* The base rule animates `padding-right` on hover/active to nudge the tab\n   out. That reflows its contents; translating the whole tab is smoother and\n   composites on the GPU. Neutralise both. */\nhtml.m-app .chat-side-tab:hover,\nhtml.m-app .chat-side-tab:active {\n  padding-right: 0;\n}\n\n@media (hover: hover) {\n  html.m-app .chat-side-tab:hover {\n    transform: translateY(-50%) translateX(-4px);\n    box-shadow: -6px 0 18px rgba(1, 13, 33, 0.26);\n  }\n}\n\nhtml.m-app .chat-side-tab:active {\n  transform: translateY(-50%) translateX(-2px);\n}\n\nhtml.m-app .chat-side-tab:focus-visible {\n  outline: 2px solid var(--color-secondary);\n  outline-offset: 2px;\n}\n\nhtml.m-app .chat-side-tab > svg {\n  flex: 0 0 auto;\n}\n\nhtml.m-app .chat-side-tab-label {\n  writing-mode: vertical-rl;\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: 0.04em;\n  line-height: 1;\n}\n\n/* IconChevronDown rotated a quarter turn points at the right edge, i.e. the\n   direction the panel slides from. Slightly held back so the icon and label\n   stay the primary marks. */\nhtml.m-app .chat-side-tab-chevron {\n  display: inline-flex;\n  transform: rotate(90deg);\n  opacity: 0.7;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html.m-app .chat-side-tab {\n    transition: none;\n  }\n}\n\n/* ── The panel it opens ─────────────────────────────────────────────────\n   .chat-widget-panel is the window; .chat-widget-body is the scrolling\n   message list inside it. An earlier pass here pinned the *body* to the\n   viewport, which detached the message list from its own header and input\n   row. The sheet treatment belongs on the panel. */\nhtml.m-app .chat-widget-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 260;\n  display: flex;\n  /* The base rule is `flex-direction: column`, where align-items controls the\n     HORIZONTAL axis and justify-content the vertical one. Overriding only\n     align/justify without restating the direction centred the panel and left\n     a 54px band of page showing beneath it. State all three. */\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: stretch;\n  background: var(--color-overlay);\n}\n\nhtml.m-app .chat-widget-panel {\n  width: 100%;\n  max-width: none;\n  height: 86vh;\n  border: none;\n  border-radius: var(--m-r-lg) var(--m-r-lg) 0 0;\n  padding-bottom: var(--m-safe-bottom);\n  box-shadow: var(--m-shadow-sheet);\n  animation: m-sheet-up var(--m-dur-sheet) var(--m-ease);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html.m-app .chat-widget-panel { animation: none; }\n}\n\nhtml.m-app .chat-widget-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  padding: var(--m-3) var(--m-gutter);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Card rails: closer to the edge\n\n   Product cards were sitting 24px from the screen edge, not the 16px gutter\n   this layer defines — .shop-main contributes 8px of its own padding and\n   .pcard-grid adds 16px on top, and the two stack. On a 390px screen that\n   is 48px of the width gone to margins before any product is drawn.\n\n   Cards are images first: the wider they are, the more of the product you\n   can actually see. So the two paddings are collapsed into one and the rail\n   gutter drops to 10px, applied through a token of its own rather than by\n   changing --m-gutter — body copy, forms and list rows still want the\n   roomier 16px, and only the card rails should move.\n\n   Effect per card, at the three common widths:\n     360px:  150 -> 165     390px:  165 -> 180     430px:  185 -> 200\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app {\n  /* Kept as its own name because a rail means something specific by it --\n     the edge a card sits on, and the point a bleeding rail returns to --\n     but it resolves to the page gutter so the two cannot drift apart. */\n  --m-gutter-cards: var(--m-gutter);\n}\n\n/* The outer container carries the gutter, so the heading, the sort toolbar\n   and the grid inside it all align to the same edge. */\nhtml.m-app .shop-main {\n  padding-left: var(--m-gutter-cards);\n  padding-right: var(--m-gutter-cards);\n}\n\n/* ...and the grid adds none of its own, which is what removes the doubling. */\nhtml.m-app .pcard-grid {\n  padding-left: 0;\n  padding-right: 0;\n  gap: var(--m-gutter-cards);\n}\n\n/* Horizontal rails bleed to the screen edges: their first and last card sit\n   on the gutter, and anything mid-scroll runs to the edge, which is what\n   makes a rail read as continuing past the screen rather than stopping. */\nhtml.m-app .cat-carousel-track,\nhtml.m-app .carousel-track,\nhtml.m-app .mtb-recent-strip {\n  padding-inline: var(--m-gutter-cards);\n}\n\n/* 8px, not the 10px gutter: this is the same column gap \"Great finds for\n   you\" uses, and the rail's cards are sized to the same third-of-the-width\n   column. Matching both is what makes a rail card land directly above a\n   grid card rather than a pixel or two out. */\nhtml.m-app .cat-carousel-track {\n  gap: var(--m-2);\n}\n\n/* The section headers above those rails keep their own 16px so the label\n   sits slightly inboard of the cards it introduces — aligning type to the\n   very edge reads as an accident rather than a decision. */\n\n/* ════════════════════════════════════════════════════════════════════════\n   Product page: promotional flags removed\n\n   The page carried four badges: \"NEW ARRIVAL\" over the image, and a row of\n   \"#1 Best Seller in <category>\", \"Trending\" and \"Verified Seller\". Hidden\n   on mobile at the customer's request.\n\n   Note that \"Verified Seller\" is in that group. It is a trust signal rather\n   than a promotional flag, but it lives in the same .pdp-badges-row and was\n   covered by \"any other flags\" -- deleting the row's rule is one line if it\n   should come back.\n\n   The \"1 / 3\" image counter is deliberately kept: it states how many photos\n   exist, which is navigation, not promotion.\n\n   This is display:none in the mobile layer rather than a change to the JSX,\n   so the desktop product page is unaffected. Say the word if they should go\n   everywhere and I will take them out of the component.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .pdp-img-badge,\nhtml.m-app .pdp-badges-row {\n  display: none;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Product page: description and \"You May Also Like\" were full-bleed\n\n   Both sections sat at left:0 / right:360 with no horizontal padding of\n   their own, so their card borders, text and buttons ran flush into both\n   screen edges -- the \"Add to Cart\" button in a related card was visibly\n   cut off at the right.\n\n   Two separate causes:\n\n   · .pdp-tabs-section and .pdp-related have no gutter. Everything else on\n     this page is inset by the page's own padding; these two are not.\n   · .pdp-related-grid is `repeat(auto-fill, minmax(190px, 1fr))`. At 360px\n     two 190px tracks do not fit, so auto-fill collapses to a single column\n     and every related product became a full-width card taller than half the\n     screen.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .pdp-related,\nhtml.m-app .pdp-tabs-section {\n  margin-left: var(--m-gutter-cards);\n  margin-right: var(--m-gutter-cards);\n}\n\n/* Two up, matching the main product grid, so a related product reads as the\n   same kind of object as one in the storefront. */\nhtml.m-app .pdp-related-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--m-gutter-cards);\n}\n\nhtml.m-app .pdp-related-card {\n  border-radius: var(--m-r);\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app .pdp-related-card:hover {\n  transform: none;\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app .pdp-related-card img {\n  aspect-ratio: 1 / 1;\n  height: auto;\n  object-fit: cover;\n}\n\nhtml.m-app .pdp-related-body {\n  padding: var(--m-3);\n  gap: var(--m-1);\n}\n\nhtml.m-app .pdp-related-body h4 {\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin: 0;\n}\n\nhtml.m-app .pdp-related-price {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-bold);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .pdp-related-original {\n  font-size: var(--m-fs-caption);\n}\n\nhtml.m-app :is(.pdp-related-seller, .pdp-related-stock-row) {\n  font-size: var(--m-fs-caption);\n}\n\n/* The description panel: desktop padding of 22px/26px inside a box that is\n   itself now inset. */\nhtml.m-app .pdp-tab-body {\n  padding: var(--m-4);\n  border-radius: 0 0 var(--m-r) var(--m-r);\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app .pdp-tab-desc p {\n  font-size: var(--m-fs-body);\n  line-height: var(--m-lh-body);\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .pdp-tab {\n  font-size: var(--m-fs-secondary);\n  padding: var(--m-3) var(--m-3);\n  white-space: nowrap;\n}\n\nhtml.m-app .pdp-related .pdp-section-h2 {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* The category overline above the product title (\"— CLOTHING\"). Removed on\n   mobile: the category is already reachable from the breadcrumb-free app bar\n   and the category rail, and on a narrow screen it pushes the product name --\n   the thing the shopper actually came for -- further down the fold. */\nhtml.m-app .pdp-cat-label {\n  display: none;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Checkout — address selection\n\n   The address book's own cards (.ab-*) are reused inside checkout. They are\n   built for a two-column desktop grid: 20px padding, a 38px icon disc and\n   48px-tall info rows, which comes to 205px per card. On a 360px screen\n   that is barely one and a half addresses per viewport, so choosing between\n   three means scrolling past the thing you are trying to compare.\n\n   Tightened to roughly 120px, which puts three on screen at once. Nothing\n   is removed -- name, icon, street, city, phone, email and the selected\n   tick are all still there, just at phone measure.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .ab-cards-grid {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-3);\n}\n\nhtml.m-app .ab-card {\n  padding: var(--m-3);\n  border-width: 1px;\n  border-radius: var(--m-r);\n  box-shadow: var(--m-shadow-sm);\n  gap: var(--m-2);\n}\n\nhtml.m-app .ab-card-top {\n  gap: var(--m-2);\n  align-items: center;\n}\n\nhtml.m-app .ab-card-icon-wrap {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  flex: 0 0 auto;\n}\n\nhtml.m-app .ab-card-icon-wrap svg {\n  width: var(--m-icon-sm);\n  height: var(--m-icon-sm);\n}\n\nhtml.m-app .ab-card-name {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .ab-selected-check {\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  flex: 0 0 auto;\n}\n\nhtml.m-app .ab-card-info {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-1);\n}\n\n/* 48px per row was the biggest single cost: three of them is 144px of a\n   205px card. The row now takes the height of its own text. */\nhtml.m-app .ab-info-row {\n  align-items: flex-start;\n  gap: var(--m-2);\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .ab-info-icon {\n  flex: 0 0 auto;\n  margin-top: 1px;\n}\n\nhtml.m-app .ab-info-icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* ── The stepper ────────────────────────────────────────────────────────\n   56px circles and 18px labels take 290px before any checkout content --\n   more than a third of the screen, on all three steps. */\nhtml.m-app .checkout-steps {\n  padding: var(--m-3) var(--m-gutter);\n  gap: var(--m-1);\n}\n\nhtml.m-app .step-number {\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  font-size: var(--m-fs-caption);\n}\n\nhtml.m-app .step-label {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-medium);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Checkout — payment method\n\n   The card lays out radio | icon | title+blurb | \"Selected\" chip in a\n   single flex row. That works at the width the design was drawn at; at\n   360px the text column collapses to about 150px, wrapping \"Cash on\n   Delivery\" onto two lines and the blurb onto eight, and the card grows\n   past 800px tall.\n\n   On mobile it becomes two rows: the radio, the icon and the copy across\n   the top, and the \"Selected\" chip beneath. Every element is the one the\n   design calls for -- they just stop competing for the same 360px.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .payment-method-card {\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr);\n  align-items: center;\n  gap: var(--m-2) var(--m-3);\n  padding: var(--m-3);\n  border-radius: var(--m-r);\n  min-height: 0;\n}\n\n/* The confirmation card is not the three-column chooser above, and must not be\n   laid out by counting children.\n *\n * It was. A grid puts each child in the next column, so when a fourth --\n * .co-cod-features, three reassurance labels -- was added to the card, it\n * landed in column 1, sized that `auto` track to its own width, and left the\n * copy track (minmax(0, 1fr)) at zero. Measured at a 368px viewport: the title\n * computed to width 0 against a scrollWidth of 72, so \"Cash on Delivery\" set\n * one character per line down a card 816px tall.\n *\n * Stated as its own row so the layout follows what the card IS -- marker, name,\n * chip -- rather than how many children it happens to have. */\n/* flex-wrap, so a label that will not fit costs the CHIP its place on the line\n   rather than breaking itself in half.\n *\n * Flex breaks lines on each item's hypothetical size -- for these, their\n * content width -- before any growing or shrinking happens. Measured at a\n * 368px viewport, 284px of usable card:\n *\n *   \"Cash on Delivery\"  26 + 12 + 139 + 12 + 87 = 276  <= 284, one line\n *   \"MTN Mobile Money\"  26 + 12 + 159 + 12 + 87 = 296  >  284, chip drops\n *\n * so the short label keeps the single-line card the design asks for, and the\n * long one keeps its name whole on line one with the chip beneath. Without\n * this the title took the squeeze instead: \"MTN Mobile Money\" had 147px for\n * the 159px it needs and wrapped to two lines, making that card 76px against\n * the other's 53px.\n *\n * Chasing the 12px difference in padding and gaps was the alternative and it\n * is not worth having: it would just move the cliff to the next label, and\n * these come from the payment provider (backend/utils/payments), not from us. */\nhtml.m-app .payment-method-card.co-selected,\nhtml.m-app .payment-method-card.co-choice {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--m-3);\n  min-height: 0;\n}\n\n/* The base sizes this marker to 26px for the confirmation card, but the\n   generic m-app .co-radio rule pins width/height AND their min- twins at 18px,\n   so it has to be restated here or the disc comes back squashed. */\nhtml.m-app .payment-method-card.co-selected .co-radio,\nhtml.m-app .payment-method-card.co-choice .co-radio {\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  min-height: 26px;\n}\n\n/* Body size, not card-title size, and the one place in this file where that is\n   a fitting decision rather than a typographic one.\n *\n * --m-fs-card-title is 1rem, and rem here is the mobile layer's 18px root, so\n * it renders at 18px rather than the 16px its token comment describes. At 18px\n * \"Cash on Delivery\" measured 148px against 147px of free width -- one pixel\n * short, so it wrapped to two lines and the clean single-row card became two.\n *\n * --m-fs-body is 0.9375rem, about 16.9px here, which brings the title to ~139px\n * and leaves 8px in hand. That margin is the point: French renders this string\n * as \"Paiement à la livraison\" and Swahili as \"Lipa Unapopokea\", so a layout\n * that only just fits the English is one translation away from wrapping again.\n * Longer locales still wrap -- they simply do it without anything breaking. */\nhtml.m-app .co-selected-title {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n}\n\n/* The .payment-method-icon and .payment-method-info rules that stood here are\n   gone with the markup -- see the note in App.css. The card's type is now\n   .co-selected-title, defined just above. */\n\n/* Sits at the far end of the same row as the title. It used to be dropped onto\n   a row of its own (grid-column: 1 / -1) to stop it stealing width from the\n   title and wrapping \"Cash on Delivery\" -- with the blurb and the reassurances\n   gone there is room for both, and the card reads as a single line. */\nhtml.m-app .co-selected-chip {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--m-1);\n  height: 26px;\n  padding: 0 var(--m-2);\n  border-radius: var(--m-r-pill);\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-semibold);\n  white-space: nowrap;\n}\n\nhtml.m-app .co-panel-title {\n  font-size: var(--m-fs-section);\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: var(--m-track-title);\n}\n\nhtml.m-app .co-protection-note {\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  gap: var(--m-2);\n}\n\n/* ── Order notes ────────────────────────────────────────────────────────── */\nhtml.m-app .co-optional {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-regular);\n  color: var(--color-text-muted);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Checkout — the forward action\n\n   Continue to Payment / Place Order carry the step forward, so they get the\n   full width and the taller control height, and sit on brand blue with navy\n   text. White on #3B82F6 is 3.1:1 and fails AA; navy on it is 5.6:1, which\n   is the rule the rest of the system already follows for filled controls.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* .btn-place-order carries both \"Continue to Payment\" and \"Place Order\".\n   (Two other class names were listed here previously -- .co-continue-btn and\n   .co-next-btn -- which exist nowhere in the app. They were guessed rather\n   than checked, and their presence made the rule look like it covered more\n   than it did.)\n\n   The base rule sets `background: linear-gradient(...)` and `color: white`.\n   An earlier version of this block set neither, so the comment claimed navy\n   on blue while the button carried on rendering white on blue -- which is\n   3.1:1 and fails AA. Both are now actually declared. */\nhtml.m-app :is(.btn-place-order, .cs-checkout-btn) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--m-2);\n  width: 100%;\n  min-height: var(--m-control-lg);\n  margin-top: var(--m-4);\n  padding: 0 var(--m-4);\n  border: none;\n  border-radius: var(--m-r-sm);\n  /* Flat, not a gradient: a gradient across a full-width button reads as a\n     banner rather than a control at this size. */\n  background: var(--color-secondary);\n  /* Navy on #3B82F6 is 5.6:1. White is 3.1:1. */\n  color: var(--color-text-on-secondary);\n  font-size: 1rem;\n  font-weight: var(--m-fw-semibold);\n  white-space: nowrap;\n}\n\nhtml.m-app :is(.btn-place-order, .cs-checkout-btn):hover:not(:disabled),\nhtml.m-app :is(.btn-place-order, .cs-checkout-btn):active:not(:disabled) {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n}\n\n/* .cs-checkout-btn is the cart's \"Proceed to Checkout\" -- the first of the\n   three forward actions in the purchase flow, the other two being\n   \"Continue to Payment\" and \"Place Order\" (both .btn-place-order).\n   It was the odd one out: 44px rather than 52, 14.7px/700 rather than\n   16px/600, a 12px radius rather than 10, and a background from a color-mix\n   that landed a shade off the brand blue. Three steps of one flow should\n   not each present a differently-shaped primary button, so it shares the\n   rule above rather than carrying its own copy of the values -- that way\n   they cannot drift apart later. */\n\nhtml.m-app .co-under-cta {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-secondary);\n  text-align: center;\n  margin: var(--m-2) 0 0;\n}\n\n/* The COD confirmation card is followed by ~100px of dead space before\n   \"Order notes\", inherited from desktop spacing between payment options. */\nhtml.m-app .payment-method-cod-confirm {\n  margin-bottom: var(--m-4);\n}\n\nhtml.m-app .cod-payment-section > * + * {\n  margin-top: var(--m-4);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Order progress tracker: horizontal rail → vertical timeline\n\n   The desktop tracker lays five steps left to right, each sized to its own\n   content with dashed connectors absorbing the slack between. That works\n   across ~700px. On a 360px phone the card's inner width is about 296px, so\n   each step gets roughly 59px -- narrower than the words in it. \"Order\n   Received\" broke to \"Order / Receive / d\", \"Seller Processing\" to\n   \"Processin / g\", and the timestamps and status pills underneath ended up\n   on different baselines from each other.\n\n   A vertical timeline is the shape this wants on a phone: each step gets the\n   full width for its label, the dots line up in a single column, and the\n   connector becomes the spine running between them. It also reads in the\n   order the events actually happen, top to bottom.\n\n   Only the axis changes. Every element -- dot, icon, label, timestamp, the\n   \"In Progress\" pill, and the done/active colouring -- is the one the\n   desktop renders.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .order-success-tracker {\n  flex-direction: column;\n  align-items: stretch;\n  padding: var(--m-4);\n  border-radius: var(--m-r);\n  box-shadow: var(--m-shadow-sm);\n  gap: 0;\n}\n\n/* Dot in a fixed 32px column, everything else in the rest of the row. */\nhtml.m-app .ost-step {\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr);\n  align-items: center;\n  column-gap: var(--m-3);\n  row-gap: 2px;\n  width: 100%;\n  text-align: left;\n}\n\nhtml.m-app .ost-dot {\n  grid-row: 1 / span 2;\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n}\n\nhtml.m-app .ost-label {\n  grid-column: 2;\n  margin: 0;\n  font-size: var(--m-fs-body);\n  line-height: var(--m-lh-snug);\n  /* The wrapping this fixes was mid-word, so let it wrap between words and\n     nowhere else. */\n  overflow-wrap: normal;\n  word-break: normal;\n  hyphens: none;\n}\n\n/* Timestamp / \"Pending\" sits directly under its own label rather than in a\n   separate row that has to stay aligned with four other columns. */\nhtml.m-app .ost-sub {\n  grid-column: 2;\n  margin: 0;\n  font-size: var(--m-fs-caption);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .ost-pill-active {\n  grid-column: 2;\n  justify-self: start;\n  margin: 2px 0 0;\n  font-size: var(--m-fs-caption);\n  white-space: nowrap;\n}\n\n/* The connector is a sibling of the steps, not a child, so it is positioned\n   into the dot column by an indent rather than by nesting. 15px = half of a\n   32px dot minus half the 2px line, which puts it exactly on the dots' axis. */\nhtml.m-app .ost-line {\n  flex: 0 0 auto;\n  width: 2px;\n  height: 18px;\n  margin: 2px 0 2px 15px;\n  /* The dashed pattern is drawn left-to-right for a horizontal rail; rotate\n     it so the dashes run down the spine instead of vanishing. */\n  background-image: repeating-linear-gradient(\n    to bottom,\n    var(--border) 0,\n    var(--border) 5px,\n    transparent 5px,\n    transparent 10px\n  );\n}\n\nhtml.m-app .ost-line-done {\n  background-image: none;\n}\n\n/* The mid-word breaking had a specific cause: App.css caps these at\n   `max-width: 80px` below 820px and `max-width: 60px` below 600px, so the\n   horizontal rail's five columns would fit. \"Order Received\" cannot fit in\n   60px at any weight, so it broke to \"Order / Receive / d\".\n\n   In a vertical timeline the label has the whole row, so the cap comes off\n   and the text wraps between words if it wraps at all. */\nhtml.m-app .ost-label,\nhtml.m-app .ost-sub {\n  max-width: none;\n  white-space: normal;\n}\n\n/* Restated after the cap is lifted: App.css also drops these to 0.7rem and\n   0.66rem below 600px, which is under this layer's 11px floor and was only\n   ever a way of squeezing five columns onto one line. */\nhtml.m-app .ost-label {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  margin: 0;\n}\n\nhtml.m-app .ost-sub {\n  font-size: var(--m-fs-caption);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Order confirmation: \"Delivering to\"\n\n   .order-success-map is decorative -- a 100x90 box filled with a\n   repeating-linear-gradient of diagonal stripes and a map glyph. It is not a\n   map: no tiles, no coordinates, nothing derived from the address beside it.\n   On desktop it sits to the right of the text as a small graphic. On a phone\n   .osa-body wraps and it becomes a wide empty striped band above the\n   address, which reads as an image that failed to load.\n\n   Nothing is lost by removing it, and roughly 100px of the fold is regained\n   for the address itself. (There IS a real map in this app -- the delivery\n   tracking page uses react-leaflet with actual coordinates. This is not it.)\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .order-success-map {\n  display: none;\n}\n\nhtml.m-app .order-success-cols {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-3);\n}\n\nhtml.m-app :is(.order-success-address, .order-success-summary) {\n  padding: var(--m-4);\n  border-radius: var(--m-r);\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app :is(.order-success-address, .order-success-summary) > h3 {\n  display: flex;\n  align-items: center;\n  gap: var(--m-2);\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-semibold);\n  margin: 0 0 var(--m-3);\n}\n\n/* The three lines are one address, so they sit as one block rather than\n   three paragraphs with 4px of air between them. */\nhtml.m-app .osa-body {\n  display: block;\n}\n\nhtml.m-app .osa-info {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-1);\n}\n\nhtml.m-app .order-success-address p {\n  margin: 0;\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n}\n\n/* The name leads, so it gets body size and weight rather than the same\n   13px as the street. */\nhtml.m-app .order-success-address p strong {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n}\n\n/* \"Change Address\" is the card's one action: a real control with a 44px tap\n   target, not an underlined run of text. Padding cancelled by an equal\n   negative margin so it gains the target without adding height. */\nhtml.m-app .order-success-address .btn-link {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--m-1);\n  margin: var(--m-2) 0 0;\n  padding: 11px 8px;\n  margin-left: -8px;\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-semibold);\n  color: var(--color-secondary-text);\n  text-decoration: none;\n}\n\n/* Order summary rows: label left, figure right, tabular so the column of\n   numbers lines up. */\nhtml.m-app .order-success-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--m-3);\n  min-height: 28px;\n  font-size: var(--m-fs-secondary);\n}\n\nhtml.m-app .order-success-row strong {\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .order-success-row.total {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-bold);\n  padding-top: var(--m-2);\n}\n\n/* \"Continue to Payment\" to the same 328px as \"Place Order\".\n *\n * The two buttons already share one rule and both are width:100%; the\n * difference was their containers. Place Order sits inside\n * .cod-payment-section, a .co-panel with 16px of padding, so it lands at\n * 328px on a 360px screen. Continue to Payment is a direct child of\n * .summary-right, which has none, so it ran the full 360px and was the only\n * thing on that step touching both screen edges.\n *\n * Inset via calc rather than a literal 328px: the number is only correct at\n * one viewport, whereas this holds the same 16px gutter at every width --\n * which is what actually makes it match, on a 360px phone and a 430px one\n * alike.\n *\n * Scoped to the direct child of .summary-right so it cannot reach the\n * step-3 button, which is already inset by its panel and would otherwise be\n * squeezed to 296px.\n */\n/* One gutter for the whole step, rather than an inset per element.\n *\n * The first version of this insetted just the button with a calc. That\n * worked for the button and left everything else on the step to its own\n * devices -- the \"Secure checkout with Buyer Protection\" note came out at\n * 326px/L17 against the button's 328px/L16, close enough to look accidental\n * rather than aligned.\n *\n * The container carries the 16px instead, and its two columns carry none, so\n * every child is plain width:100% and they cannot drift apart. Step 3 is a\n * different container (.checkout-side) and is unaffected -- it already sat\n * at 328/L16 via its own panel. */\nhtml.m-app .order-summary-container {\n  padding-left: var(--m-4);\n  padding-right: var(--m-4);\n  gap: var(--m-3);\n}\n\nhtml.m-app .summary-left,\nhtml.m-app .summary-right {\n  padding-left: 0;\n  padding-right: 0;\n}\n\nhtml.m-app .summary-right > .co-under-cta {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* Now that the container provides the gutter, the note is width:100% like\n   everything else beside it. */\nhtml.m-app .co-protection-note {\n  width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n  padding: var(--m-3);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n}\n\n/* Step 2's note lives INSIDE .summary-left. That used to be a card with a\n   1px border, so the note needed to step back out over it to share the\n   button's edge. .summary-left is no longer a card on mobile (see below),\n   so there is no border to compensate for and the note is plain 100%. */\nhtml.m-app .summary-left > .co-protection-note {\n  width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n/* The CTA needs the same correction, and was the one element that missed it.\n *\n * App.css insets Place Order and its two notes by 14px a side, so that on the\n * app's full-bleed checkout they line up with the payable total's inner edge\n * rather than the panel's. This layer takes the opposite approach one level\n * up -- the container owns the gutter and every child is a plain width:100%\n * (see the block at the top of this section) -- and it sets that width on\n * .btn-place-order directly.\n *\n * Those two decisions collide: width:100% is resolved against the column's\n * content box, so App.css's surviving side margins are added OUTSIDE it and\n * the button overhangs its own column by 28px. The notes beside it were\n * already brought back in by the two rules above; the button was not, which\n * is why it alone hung over the edge.\n *\n * Zeroed rather than un-setting the width: the margins are what disagree with\n * this layer, and width:100% is what every other child on the step uses. */\nhtml.m-app :is(.btn-place-order, .cs-checkout-btn) {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n/* .summary-left is a .co-panel -- border, 16px radius, shadow -- wrapping\n   two things that are already cards: the \"Delivering to\" block and the\n   order-item rows. On a 360px screen the outer border ends up running\n   within a few pixels of the inner cards' own borders, so the two read as\n   one doubled, badly-padded line rather than as a card containing cards.\n   \n   Desktop has room for the nesting to be legible; mobile does not. Here\n   the outer panel stops being a surface and becomes just a grouping: the\n   heading stays, the chrome goes, and the inner cards carry the edges. */\nhtml.m-app .summary-left.co-panel {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none;\n  box-shadow: none;\n}\n\n/* .summary-left is a flex column with gap:20px, so the space between the\n   heading, the address block, the items and the note is already uniform --\n   it just wasn't visible while every child ALSO carried its own margin,\n   which adds to a flex gap rather than collapsing into it. That is what\n   made the three gaps 32 / 24 / 38px instead of one step.\n   \n   The margins go and the gap alone does the spacing. Nothing here sets a\n   margin-top for the same reason: it would stack on the gap again. */\nhtml.m-app .summary-left.co-panel > .co-panel-title {\n  margin-bottom: 0;\n}\n\nhtml.m-app .summary-left.co-panel > :is(.address-section, .order-items-section, .co-protection-note) {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\nhtml.m-app .summary-left .order-items-section > .order-items {\n  margin-bottom: 0;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   Order success: the confirmation notice\n\n   Behaves like a toast that lives inline. It says its piece and then\n   collapses in place after five seconds rather than sitting there\n   permanently restating the heading above it. Collapsing (height, margin and\n   opacity to zero) rather than fading alone means nothing below it jumps\n   when it goes.\n\n   GREEN, at the customer's request. Worth recording that the design system\n   says otherwise: green is scoped to product ratings and the confirm dialog,\n   and CLAUDE.md names \"success messages\" as a case it must NOT be used for,\n   because with only four hues a colour cannot carry meaning on its own.\n\n   Two things make this defensible rather than a straight violation. It uses\n   --color-confirm-safe, the green the system ALREADY sanctions for the\n   confirm dialog, rather than a fifth hue invented here -- so there is still\n   exactly one green in the app, with dark-mode variants already tuned. And\n   the notice keeps its tick icon and its sentence, so the meaning never\n   rests on the hue.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .order-success-trust {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--m-2);\n  margin: var(--m-3) 0;\n  padding: var(--m-3);\n  border: 1px solid color-mix(in srgb, var(--color-confirm-safe) 30%, transparent);\n  border-radius: var(--m-r-sm);\n  background: var(--color-confirm-safe-soft);\n  color: var(--color-confirm-safe);\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n  overflow: hidden;\n  transition:\n    opacity var(--m-dur) var(--m-ease),\n    max-height var(--m-dur-sheet) var(--m-ease),\n    margin var(--m-dur-sheet) var(--m-ease),\n    padding var(--m-dur-sheet) var(--m-ease),\n    border-width var(--m-dur-sheet) var(--m-ease);\n  max-height: 200px;\n}\n\nhtml.m-app .order-success-trust svg {\n  flex: 0 0 auto;\n}\n\nhtml.m-app .order-success-trust-hidden {\n  max-height: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-width: 0;\n  opacity: 0;\n  /* Nothing left to interact with once it has gone. */\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html.m-app .order-success-trust {\n    transition: none;\n  }\n}\n\n/* ── Follow-up line ─────────────────────────────────────────────────────\n   Replaces the \"What's Next?\" block: a heading, a paragraph restating that\n   the seller is preparing the order, and three mini-tiles that were labels\n   rather than links. One sentence pointing at where the status actually\n   lives does the same job. */\nhtml.m-app .order-success-followup {\n  margin: var(--m-4) 0;\n  padding: 0 var(--m-gutter-cards);\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-body);\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\nhtml.m-app .order-success-followup .btn-link {\n  display: inline;\n  min-height: 0;\n  padding: 0;\n  font-size: inherit;\n  font-weight: var(--m-fw-semibold);\n  color: var(--color-secondary-text);\n  text-decoration: underline;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   My Orders: one left edge for the whole page\n\n   .oh-page sits at L20 and pads 16, so its content lands at L36 -- the\n   header, the filter bar and the order rows all line up there. The metric\n   rail was the exception: data.css bleeds rails to the screen edge with a\n   negative inline margin so cards can scroll off it, which put its cards at\n   L20, 16px outboard of everything beneath them.\n\n   Bleeding is right for a rail on the storefront, where it runs to the edge\n   of the screen. Here it runs to the edge of a padded page and lands on no\n   edge in particular, so it just reads as a misalignment. The rail keeps its\n   horizontal scrolling and loses the bleed.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .oh-page .oh-stats-grid {\n  margin-left: 0;\n  margin-right: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* ── The order card ─────────────────────────────────────────────────────\n   Each order is a card: identity at the top, the product in the middle, the\n   amount and status at the foot. The labels above each field come from the\n   desktop table's column headers, which is right -- but at 11px uppercase\n   they were competing with the values they label. */\nhtml.m-app .oh-row-wrap {\n  border: 1px solid var(--m-hairline);\n  border-radius: var(--m-r);\n  background: var(--m-surface-card);\n  box-shadow: var(--m-shadow-sm);\n  overflow: hidden;\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .oh-row {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-2);\n  width: 100%;\n  padding: var(--m-3);\n  border: none;\n}\n\n/* A cell is a STACK of label/value pairs, not one pair: .oh-cell-order holds\n   \"Order ID\" + the id + \"Placed on\" + the date, all as siblings. An earlier\n   version here laid the cell out as a row with space-between, which put all\n   four on one line and wrapped every one of them (\"#ORD- 64153\", a date over\n   three lines). Column, as the markup intends. */\nhtml.m-app .oh-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  width: 100%;\n  padding: 0;\n  border: none;\n  text-align: left;\n  font-size: var(--m-fs-secondary);\n}\n\nhtml.m-app .oh-cell-label {\n  font-size: var(--m-fs-label);\n  font-weight: var(--m-fw-medium);\n  text-transform: none;\n  letter-spacing: 0;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* Labels and values are flat siblings with no wrapper per pair, so the\n   grouping is made by spacing: a label that follows a value starts a new\n   pair and gets air above it; the first one does not. */\nhtml.m-app .oh-cell > * + .oh-cell-label {\n  margin-top: var(--m-2);\n}\n\nhtml.m-app .oh-cell > p {\n  margin: 0;\n}\n\n/* The product is the thing being bought, so it gets the full width and a\n   thumbnail rather than a right-aligned value. */\nhtml.m-app .oh-cell-product {\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: var(--m-3);\n  text-align: left;\n  padding: var(--m-3) 0;\n  margin: var(--m-1) 0;\n  border-top: 1px solid var(--m-hairline);\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .oh-cell-product .oh-cell-label {\n  display: none;\n}\n\nhtml.m-app :is(.oh-prod-img, .oh-prod-img-placeholder) {\n  flex: 0 0 auto;\n  width: 48px;\n  height: 48px;\n  border-radius: var(--m-r-xs);\n  object-fit: cover;\n}\n\nhtml.m-app .oh-prod-info {\n  min-width: 0;\n  flex: 1 1 auto;\n  text-align: left;\n}\n\nhtml.m-app .oh-prod-name {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  line-height: var(--m-lh-snug);\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\nhtml.m-app :is(.oh-prod-seller, .oh-prod-qty, .oh-prod-more) {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\nhtml.m-app .oh-prod-price {\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-semibold);\n  font-variant-numeric: tabular-nums;\n  margin: 0;\n}\n\nhtml.m-app .oh-order-id {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .oh-order-date {\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n}\n\nhtml.m-app .oh-amount {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-bold);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Actions sit on their own row at the foot, sharing the width evenly. */\nhtml.m-app .oh-cell-actions {\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: var(--m-2);\n  padding-top: var(--m-3);\n  margin-top: var(--m-1);\n  border-top: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .oh-cell-actions .oh-cell-label {\n  display: none;\n}\n\nhtml.m-app .oh-cell-actions button {\n  flex: 1 1 auto;\n  min-height: var(--m-touch);\n  padding: 0 var(--m-3);\n  border-radius: var(--m-r-xs);\n  font-size: var(--m-fs-secondary);\n  white-space: nowrap;\n}\n\n/* The amount cell carries a payment-state badge: \"Paid\" once delivered,\n   otherwise \"COD\". The Payment Method row directly beneath already says COD,\n   so on an undelivered order the word appeared twice in one card. Only the\n   duplicate is hidden -- \"Paid\" still shows, because that is a state the\n   Payment Method row does not tell you. */\nhtml.m-app .oh-cell-amount .oh-cod-badge {\n  display: none;\n}\n\n/* Status pills sit inline with their label rather than filling the row. */\nhtml.m-app .oh-cell :is(.oh-paid-badge, .oh-status-pill) {\n  align-self: flex-start;\n  margin-top: var(--m-1);\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n   One left edge, everywhere\n\n   Every screen should sit on the same gutter as the product rails -- the\n   edge \"You May Also Like\" uses. Setting --m-gutter alone did not achieve\n   that, because several pages nest a padded container inside another padded\n   one and the two stack: .settings-page and .settings-container both took\n   the gutter and landed content at 20px; the orders page stacked three\n   levels and landed at 30px.\n\n   So the gutter is applied once, at the OUTERMOST container, and any of\n   these wrappers nested inside another gets none. A page cannot then\n   accumulate an edge by adding a wrapper.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app :is(\n  .settings-page, .settings-container, .dash-page, .oh-page, .wl-page,\n  .ntf-page, .ab-page, .pf-page, .cartpg-grid, .checkout-container,\n  .legal-page, .about-page, .careers-page, .privacy-page, .cookie-page,\n  .order-summary-container\n) :is(\n  .settings-page, .settings-container, .dash-page, .oh-page, .wl-page,\n  .ntf-page, .ab-page, .pf-page, .cartpg-grid, .checkout-container,\n  .legal-page, .about-page, .careers-page, .privacy-page, .cookie-page,\n  .order-summary-container\n) {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* The pages that carry their own base padding on top of the layer's gutter.\n   Each of these landed 10-20px further in than the rails they sit above. */\nhtml.m-app :is(.oh-page, .wl-page, .pf-page, .legal-page, .about-page) {\n  padding-left: var(--m-gutter);\n  padding-right: var(--m-gutter);\n}\n\n/* Inner cards on the orders and profile pages were adding a second inset of\n   their own on top of the page's. */\nhtml.m-app .oh-page > *,\nhtml.m-app .pf-page > * {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n/* Top Sales / Trending / Great finds and the product grid are deliberately\n   NOT touched here. They already sit on the reference edge and the customer\n   asked for them left alone; this section is only about the navigation\n   pages (orders, profile, wishlist, settings, and the info pages). */\n\n/* The wrapper around the account and info pages carried 20px of horizontal\n   padding, which is what pushed My Orders, Profile, Wishlist, Notifications\n   and the legal pages to a 30px edge while the rails beside them sat at 10.\n   It keeps its vertical padding -- only the horizontal half is the layer's\n   to decide, and the page inside it supplies that. */\nhtml.m-app .page-shell-pad {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* ── Order confirmation: onto the same edge as everything else ──────────── */\n\n/* .order-success-wrap is a centred flex column with no horizontal padding, so\n   every width:100% child under it -- the tracker, the items card, the address\n   and summary cards, the follow-up line, the recommendations grid -- sat flush\n   against the screen at L0, while the cards' own 18px/20px padding put their\n   text at L21. Two different edges on one screen, and neither was the 10px the\n   rest of the app uses.\n   \n   The gutter belongs on the wrap rather than on each section: the sections are\n   width:100% by design (they are cards), so padding the one container moves all\n   of them together and keeps the card padding doing what it should. The\n   centred hero, title and icon are unaffected -- align-items:center makes them\n   shrink-to-fit, so they stay centred in whatever width the wrap gives them. */\nhtml.m-app .order-success-wrap {\n  padding-left: var(--m-gutter);\n  padding-right: var(--m-gutter);\n}\n\n/* ── Top Sales rail: same page surface as the feed sections ────────────── */\n\n/* The rail sat on a white panel -- .cat-row painted white with 8px of\n   padding, .cat-row-inner painted white again with 14px and a 6px radius --\n   inside an already-white page. Two nested panels you cannot see, whose only\n   visible effect was to push the cards to a 32px edge while \"Great finds for\n   you\" below sat at 10px with no panel at all.\n   \n   The panel goes. The rail's own padding-inline then puts its cards on the\n   same 10px edge as the grid, and the header takes the gutter directly so\n   the title lines up with both. */\nhtml.m-app :is(.cat-row, .cat-row-inner) {\n  padding-left: 0;\n  padding-right: 0;\n  background: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n\nhtml.m-app .cat-row-header {\n  padding-left: var(--m-gutter);\n  padding-right: var(--m-gutter);\n}\n\n/* Cards size to their own content. With the image tile now reliably square\n   they all come out the same height anyway, but stretching to the tallest is\n   what turned one portrait thumbnail into 350px-tall cards across the rail. */\nhtml.m-app .cat-carousel-track {\n  align-items: flex-start;\n}\n\n/* ── Hero carousel: the slide contains its own contents ────────────────── */\n\n/* .slide-content stacked a badge, a headline, a subtitle and a 44px CTA\n   inside 20/22/18px of padding with 6px gaps: 189px of content in a 185px\n   slide. The slide clips (overflow: hidden), so the overflow did not show as\n   a spill -- it showed as the CTA and the subtitle being sliced through,\n   mid-word and mid-glyph, which is what \"not fitting inside the card\" looked\n   like from the outside.\n   \n   The fix is on both axes. Vertically: tighter padding and gaps, and a hard\n   max-height so the box can never exceed the slide again whatever copy an\n   admin types. Horizontally: the text column was capped at 68% of a 299px\n   slide, leaving 135px of usable width for a headline -- roughly two words a\n   line. 78% is still narrow enough to keep the product visible behind it. */\nhtml.m-app .slide-content {\n  /* width, not just max-width: .slide-content is a flex item, so it was\n     sizing to its own content (167px) and the 68%/78% cap never came into\n     play at all. Claiming the width is what actually gives the headline\n     room -- otherwise the copy sets the column and the column stays narrow. */\n  width: 78%;\n  max-width: 78%;\n  max-height: 100%;\n  padding: var(--m-4);\n  gap: var(--m-1);\n  overflow: hidden;\n}\n\n/* Long copy now ends in an ellipsis on a line boundary instead of being cut\n   through the middle of a letter. Two lines for the headline, one for the\n   subtitle: that is what fits above a 44px CTA at this slide height. */\nhtml.m-app .slide-title {\n  font-size: var(--m-fs-section);\n  line-height: var(--m-lh-snug);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\nhtml.m-app .slide-subtitle {\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
